/* eslint-disable */
import pako from "pako";
import { trackEvent, identifyVisitor } from "./analytics";
import { StylesFilter, StylesFilter_Blazer, StylesFilter_kurta } from "../Data"
import { db, auth } from "../firebase"
import { functions } from "../firebase"
import { addData, handleFireBaseUpload } from "../Firebase/firestore"
import { getData, getDatafromDoc } from "../Firebase/firestoreGet"
//import { compress, compressToEncodedURIComponent, compressToUTF16, decompress, decompressFromEncodedURIComponent, decompressFromUTF16 } from 'lz-string';
import { Types } from "../Data"
import { clientOf } from "../Business/businessCart";
import { calPrice, chargedPieces, repairCart, repairCartItem, allocateOrderValue, isFirestoreJunk, firestorePath } from "./orderPricing";
import { clothType } from "../Data/fabricType";
export { calPrice, chargedPieces, repairCart, repairCartItem, allocateOrderValue };


const SADRI_BASE_POCKET_STYLE_CODES = ["EE", "AA", "DD", "CC", "SS", "N"];
const SADRI_BASE_EMBROIDERY_DISABLED_CODES = ["EE", "CC", "SS", "N"];
const SADRI_COLLAR_EMBROIDERY_DISABLED_CODES = ["L", "M", "N"];

const sadriHasBasePocket = (styleCode) => SADRI_BASE_POCKET_STYLE_CODES.includes(String(styleCode || "").trim().toUpperCase());
const sadriBaseEmbroideryDisabled = (styleCode) => SADRI_BASE_EMBROIDERY_DISABLED_CODES.includes(String(styleCode || "").trim().toUpperCase());
const sadriCollarEmbroideryDisabled = (styleCode) => SADRI_COLLAR_EMBROIDERY_DISABLED_CODES.includes(String(styleCode || "").trim().toUpperCase());

const backendURL = "https://suits-backend.vercel.app"
// const backendURL = "http://localhost:1337"

/**
 * Payment endpoints now ship with the site (api/razorpay.js, api/verification.js)
 * and suits-backend is only a fallback. It went down and took checkout's
 * order_id with it, which is how money got taken against no Razorpay order.
 *
 * Resolves to parsed JSON, or null if this host has no such route. The SPA
 * rewrite serves index.html for unknown paths, so an HTML body means "not here"
 * rather than a real answer — hence the content-type check.
 */
export const postToPaymentApi = async (path, { body, headers } = {}) => {
    const targets = [`/api/${path}`, `${backendURL}/${path}`];

    for (const url of targets) {
        try {
            const resp = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json", ...(headers || {}) },
                body: JSON.stringify(body || {}),
            });
            if (!resp.ok) continue;
            if (!(resp.headers.get("content-type") || "").includes("application/json")) continue;
            return await resp.json();
        } catch (e) {
            // try the next target
        }
    }
    return null;
};

export const createNotification = async (type, title, message, link = "", details = {}) => {
    try {
        const notificationData = {
            type,
            title,
            message,
            details,
            timestamp: new Date(),
            read: false,
            link
        };
        const coll = db.collection('Notifications');
        await addData(coll, "", notificationData);
        return true;
    } catch(e) {
        console.error("Error creating notification: ", e);
        return false;
    }
};

/**
 * A mail that could not be sent is parked in Firestore rather than dropped.
 *
 * Every caller of senEmail swallowed failures, so when suits-backend went down
 * order confirmations simply stopped and nobody knew. These rows are the record
 * of what should have gone out, and can be replayed once a sender is
 * configured.
 */
const parkUnsentMail = async (params, reason) => {
    try{
        await addData(db.collection("MailQueue"), "", {
            ...params,
            status: "unsent",
            reason: reason || "unknown",
            createdAt: new Date(),
        })
    }catch(e){
        console.warn("could not park unsent mail", e?.message || e)
    }
}

// Best-effort: the confirmation mail must never be able to take an order down
// with it. Tries /api/sendMail (ships with this site), then the old backend.
export const senEmail = async (params)=>{
    try{
        const res = await postToPaymentApi("sendMail", { body: params })
        if(res && res.status === 0) return true

        await parkUnsentMail(params, res ? "rejected" : "no_transport")
        return false
    }catch(e){
        console.warn("senEmail failed", e?.message || e)
        await parkUnsentMail(params, "threw")
        return false
    }
}

// Sends the styled "MAVIINCI atelier" email (same Cloud Function template the admin
// panel uses) to the logged-in customer. Best-effort: never throws so it can't break
// order/review flow. Delivered only to the authenticated user's own email (enforced server-side).
export const AppointReq = async(data)=>{
    try{
        const headers = {
            "Content-Type" : "application/json"
        }        

        
        
        const collection = db.collection("Users").doc("Requests").collection(data["email"] || "Anonymous")
        await addData(collection, "", data);

        trackEvent("appointment", { city: data["city"] || "" });
        identifyVisitor({ name: data["name"], email: data["email"], phone: data["phone"] });

        // Trigger real-time notification
        const appointmentDetails = [
            data["name"] && `Name: ${data["name"]}`,
            data["city"] && `Location: ${data["city"]}`,
            data["email"] && `Email: ${data["email"]}`,
            data["des"] && `Request: "${data["des"]}"`
        ].filter(Boolean).join(" | ");

        // Use exact formType (appointment/getQuotation/wedding/business/franchise) as notification type
        const notifType = data["formType"] || "appointment";

        const appointmentDetailsObj = {
            formType: notifType,
            subject: data["subject"] || "",
            issueType: data["issueType"] || "",
            orderNo: data["orderNo"] || "",
            name: data["name"] || "",
            email: data["email"] || "",
            city: data["city"] || "",
            phone: data["phone"] || "",
            organization: data["organization"] || "",
            orders: data["orders"] || "",
            designation: data["designation"] || "",
            eventName: data["eventName"] || "",
            campusName: data["campusName"] || "",
            message: data["des"] || "",
            date: data["date"] || "",
        };

        const notifTitles = {
            getQuotation: "New Quotation Request",
            appointment: "New Campus / Stall Appointment",
            wedding: "New Wedding Outfit Request",
            business: "New Uniform Quotation Request",
            franchise: "New Smart Kiosk Franchise Enquiry",
        };

        await createNotification(
            notifType,
            notifTitles[notifType] || "New Appointment Request",
            appointmentDetails || `A new request has been received from ${data["email"] || 'Anonymous'}.`,
            "/admin/1",
            appointmentDetailsObj
        );

        // The request itself is already saved above, so this is only the
        // notification. It used to go to suits-backend/appointment; it rides
        // the same mail path as everything else now, and is parked rather than
        // lost if no sender is configured.
        // Details to the shop; the customer gets a plain acknowledgement, since
        // the mail endpoint no longer puts caller-written text in mail to an
        // address the caller chose.
        senEmail({
            toShop: true,
            email: data["email"],
            name: data["name"],
            phone: data["phone"],
            items: data["orders"] || data["city"] || "Appointment request",
        }).catch(() => {})
        if (data["email"]) return await senEmail({ email: data["email"] })
        return true
    }catch(e){
        console.log(e)
        return false
    }
}


export const sendCustomerMail = async (payload)=>{
    try{
        if(!payload || !payload.message) return false;
        const sendCustomerEmail = functions.httpsCallable('sendCustomerEmail');
        await sendCustomerEmail({
            to: payload.email || "",
            type: payload.type || "order",
            subject: payload.subject || "A note from MAVIINCI",
            message: payload.message,
            sectionTitle: payload.sectionTitle || "",
            details: {
                name: payload.name || "",
                phone: payload.phone || "",
                orderNo: payload.orderNo || "",
                orders: payload.orders || "",
                city: payload.city || "",
                organization: payload.organization || "",
            },
            // Forwarded so the mail can render a tax invoice. This builds a
            // fixed payload, so anything not named here never reaches the
            // function — which is why the invoice was silently absent.
            ...(payload.invoice ? { invoice: payload.invoice } : {}),
        });
        return true;
    }catch(e){
        console.log("sendCustomerMail error", e);
        return false;
    }
}


/**
 * Firestore rejects a write outright if any field is `undefined`, and the whole
 * batch goes with it. That is how a captured payment ended up with no order:
 * when /razorpay is down the checkout opens without an order_id, Razorpay then
 * returns no razorpay_order_id, and `payment_order_id: undefined` killed the
 * commit. Nulls are storable and still say "we do not have this".
 */
const storable = (value) => {
    if (value === undefined) return null;
    if (value === null || typeof value !== "object") return value;
    if (value instanceof Date) return value;
    if (Array.isArray(value)) return value.map(storable);
    if (typeof value.toDate === "function") return value;
    if (isFirestoreJunk(value)) return firestorePath(value);
    return Object.keys(value).reduce((acc, key) => {
        acc[key] = storable(value[key]);
        return acc;
    }, {});
};

export const postOrder = async(order)=>{

    try{
        console.log("POST Order")

        let orders = repairCart(JSON.parse(localStorage.getItem('sel')))

        const savedAddress = JSON.parse(localStorage.getItem('a')) || {}
        const deliveryAddress = savedAddress.delivery || savedAddress || {}
        const billingAddress = savedAddress.billing || deliveryAddress
        // Only a clone order needs a pickup (we collect the garment to copy).
        const isCloneOrder = Array.isArray(orders) && orders.some((o) => o?.measurements?.type === 3)
        const pickupAddress = isCloneOrder ? (savedAddress.pickup || deliveryAddress) : null
        const invoiceEmail = deliveryAddress.email || billingAddress.email || order.email || "guest@maviinci.com"
        const customerPhone = order.phone || deliveryAddress.phone || billingAddress.phone || ""
        identifyVisitor({
            name: deliveryAddress.name || billingAddress.name || order.name,
            email: invoiceEmail,
            phone: customerPhone,
        })
        const addressPayload = {
            delivery: deliveryAddress,
            billing: billingAddress,
            pickup: pickupAddress,
        }
        

        console.log("Orders" , orders)

        if(orders){ 
            // // console.log("Checking order details",order)
            for(let i = 0;i<orders.length;i+=1){
                orders[i]["payment_order_id"] = order["razorpay_order_id"]
                orders[i]["payment_id"] = order["razorpay_payment_id"]
                orders[i]["Address"] = deliveryAddress
                orders[i]["addresses"] = addressPayload
                orders[i]["billingAddress"] = billingAddress
                orders[i]["pickupAddress"] = pickupAddress
                orders[i]["status"] = { status:0, Date : new Date() }
            }
            // console.log("dumping in DB", orders)
            
            const collection = db.collection('Orders')
            var batch = db.batch();
            // console.log("passing this")
            const email = invoiceEmail
            const curr = new Date()

            const OrderID = curr.getTime().toString()+"M"

            // What each item really cost: its own discount first, then its share
            // of the cart-level savings (coupon, coins, the prepaid offer), so the
            // bill and invoice add up to the order value the customer agreed to.
            // The bill used to carry the gross price (₹6,502 on a ₹5,948 order).
            const itemTotals = allocateOrderValue(orders, order["orderValue"] || order["price"])

            var i = 0
            const pending = []
            orders.forEach((doc) => {
                i = i+1
                // One millisecond apart per item. This loop is synchronous, so
                // `new Date()` here returned the same value for every item and
                // each batch.set overwrote the last: a two-item bag saved one item.
                const ID = (curr.getTime() + i - 1).toString()
                // console.log("ID from orders, ", ID)
                const finalOrder = {
                    ...doc,
                    ...{
                        "Date": Date(),
                        "id": ID,
                        "email": email,
                        "userEmail": order.email || email,
                        "phone": customerPhone,
                        // Lets a guest read their own order back from the same
                        // browser: the rules allow an order to its email, phone
                        // or the uid that placed it, and a guest has only a uid.
                        "uid": (auth && auth.currentUser && auth.currentUser.uid) || "",
                        "orderId": OrderID,
                        "paymentMethod": order.paymentMethod || "prepaid",
                        // False when /verification could not be reached. The money is
                        // still captured — these are the rows to reconcile by hand.
                        "paymentVerified": Boolean(order.verified),
                        // Cart-level hisab (accounts app ke liye): kitna charge hua
                        // (COD me sirf token) vs poore order ka daam — har item-doc
                        // pe same, orderId se group karke ek baar padha jata hai
                        "cartPaid": Number(order["price"] || 0),
                        "cartValue": Number(order["orderValue"] || order["price"] || 0),
                        "cartItems": orders.length,
                        // The code and coins checkout took off this bag, and the
                        // bag they were judged on. api/place-order.js checks them.
                        "offers": order.offers ? {
                            subtotal: Number(order.offers.subtotal) || 0,
                            coupon: order.offers.coupon || "",
                            couponDiscount: Number(order.offers.couponDiscount) || 0,
                            coinsUsed: Number(order.offers.coinsUsed) || 0,
                            businessDiscount: Number(order.offers.businessDiscount) || 0,
                            businessPct: Number(order.offers.businessPct) || 0,
                            prepaidDiscount: Number(order.offers.prepaidDiscount) || 0,
                        } : null,
                        // A boutique's piece carries the client it is for, so
                        // tailoring, packing and labels can name them.
                        ...(order.offers && Number(order.offers.businessDiscount) > 0 ? {
                            business: true,
                            clientName: clientOf(doc) || "",
                        } : {}),
                        "invoice": {
                            id: `INV-${OrderID}-${i}`,
                            email,
                            createdAt: new Date(),
                            status: "pending_email",
                        },
                        "bill": {
                            invoiceId: `INV-${OrderID}-${i}`,
                            billingAddress,
                            deliveryAddress,
                            pickupAddress,
                            email,
                            phone: customerPhone,
                            total: itemTotals[i - 1],
                            listPrice: doc?.item_type === 0 ? 250 : Number(doc?.price || 0),
                            savings: Math.max(0, (doc?.item_type === 0 ? 250 : Number(doc?.price || 0)) - itemTotals[i - 1]),
                            paymentOrderId: order["razorpay_order_id"],
                            paymentId: order["razorpay_payment_id"],
                            paymentMethod: order.paymentMethod || "prepaid",
                        }
                    }
                }
                pending.push({ id: ID, data: storable(finalOrder) });
            })

            // Ask the server to write the order. It checks the payment with
            // Razorpay and stamps serverVerified/amountCaptured, which the rules
            // do not let the browser write. If it cannot - not configured,
            // Razorpay slow, signature rejected - the browser writes the order
            // as before and the admin panel shows it unverified. A paid order
            // is never dropped here.
            let placedOnServer = false
            if (order["razorpay_payment_id"] && order["razorpay_order_id"] && order["razorpay_signature"]) {
                try {
                    // Coins belong to the signed-in account; the server reads
                    // which one from this token, never from the order itself.
                    let idToken = ""
                    try {
                        if (auth && auth.currentUser && !auth.currentUser.isAnonymous) idToken = await auth.currentUser.getIdToken()
                    } catch (e) { idToken = "" }
                    const resp = await fetch("/api/place-order", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            payment: {
                                razorpay_order_id: order["razorpay_order_id"],
                                razorpay_payment_id: order["razorpay_payment_id"],
                                razorpay_signature: order["razorpay_signature"],
                            },
                            docs: pending,
                            idToken,
                        }),
                    })
                    // 409: this payment already produced an order - a retry
                    // after a lost response. Writing again would duplicate it.
                    placedOnServer = resp.status === 409 || (resp.ok && (await resp.json()).status === 1)
                } catch (e) {
                    placedOnServer = false
                }
            }
            if (!placedOnServer) {
                pending.forEach((p) => batch.set(collection.doc(p.id), p.data))
                await batch.commit()
            }
            
            // Trigger real-time notification
            await createNotification(
                "order",
                "New Order Placed",
                `Order ID: ${OrderID} placed by ${email || 'Anonymous'} for ₹${order["price"] || '0'}.`,
                "/admin/0"
            );
            
            // paymentStatus({...payment, "id":1})

            localStorage.removeItem('sel')
            localStorage.removeItem('a')

            const pramsData = {
                "email" : email,
                "name" : deliveryAddress.name,
                "orderId" :  OrderID ,
                "items" : i.toString(),
                "price" : order["price"],
                "phone": customerPhone,
                "billingAddress": billingAddress,
                "deliveryAddress": deliveryAddress,
                "invoiceId": `INV-${OrderID}`,
            }
            // setcheck({...checkoutData, ...pramsData})
            
            console.log("User Detaisl", pramsData)
            
            // The customer's confirmation is the branded Cloud Function mail
            // below; this is the shop's own copy, so it must not go out to the
            // customer as well.
            senEmail({ ...pramsData, toShop: true }).catch(()=>{})

            // Styled atelier confirmation email to the buyer (best-effort)
            sendCustomerMail({
                email,
                name: deliveryAddress.name || billingAddress.name || "",
                phone: customerPhone,
                city: deliveryAddress.city || billingAddress.city || "",
                orderNo: OrderID,
                orders: i.toString(),
                type: "orderConfirmation",
                subject: "Your MAVIINCI Order is Confirmed",
                sectionTitle: "Order Summary",
                message: `Thank you for your order. We have received your order ${OrderID} (${i} item${i > 1 ? 's' : ''}) worth ₹${order["price"] || '0'}. Our atelier has begun crafting your bespoke pieces and you will be notified at every stage.`,
                // Priced per item so the mail can show a real GST breakdown —
                // the rate depends on each garment's price, not the cart total.
                invoice: {
                    invoiceId: `INV-${OrderID}`,
                    buyerStateCode: deliveryAddress.stateCode || billingAddress.stateCode || "",
                    items: orders.map((doc, k) => ({
                        desc: doc?.name || doc?.type || "Bespoke garment",
                        qty: 1,
                        price: itemTotals[k],
                    })),
                },
            }).then((ok)=>{
                // Nothing else tells us the customer's confirmation never went.
                if(!ok) parkUnsentMail({ ...pramsData, kind: "customer_confirmation" }, "cloud_function_failed")
            }).catch(()=>{})
            // setLoading(false)
            // console.log("postOrder", result)

            return {...pramsData, ...{status: 1 } }
        }else{
            return { status: 0, reason: "empty_cart" }
        }
    } catch(e){
        console.error("postOrder failed", e)
        return { status: 0, reason: "write_failed", error: e?.message || String(e) }
    }
}


export const paymentVerification = async(response, atype = 0)=>{
    try{
        // console.log("Verification : ", response)
        const params = {
            "razorpay_payment_id": response.razorpay_payment_id,
            "razorpay_order_id": response.razorpay_order_id
        }
        const headers = {
          "x-razorpay-signature":  response.razorpay_signature,
          "Content-Type" : "application/json"
        }

        const options = {
            method : 'POST'
        }
        
        
        const res = await postToPaymentApi("verification", {
            body: { ...params, razorpay_signature: response.razorpay_signature },
            headers: { "x-razorpay-signature": response.razorpay_signature },
        })

        return { ...(res || { status: 0 }), ...params };
    }catch(e){
        return { status: 0 }
    }
}


export const checkCategory =(category)=> {
    if(category === "suit" || category === "kurta" || category === "only_kurta"){
        return true
    } else {
        return false
    }
}

export const changeImgState = (sel, type, pos, setImgState, setLoad, category, imgState, style)=>{
    try{
        var l = 0;

        if(!checkCategory(category)){
            if(category === "formal"){
                if(type === "Shirt"){

                    if(pos === "F"){
                        if(imgState !=0 || style === "Cuffs"){
                            setImgState(1)
                            setLoad(false)
                        } else{
                            l = 1;
                        }
                        
                    }else{
                        setImgState(2)
                        setLoad(false)
                    }
                } else {
                    if(pos === "F"){
                        if(imgState !== 0){
                            setImgState(3)
                            setLoad(false)
                        } else {
                            l=1;
                        }
                        
                    }else{
                        setImgState(4)
                        setLoad(false)
                    }
                    
                }
            } else if (category === "blazer"){
                
                if(pos === "F"){
                    // if(imgState === 0){
                    
                    setImgState(imgState ===2 ? 1 : imgState)
                    l = 1;
                    // }
                    // setImgState(1)
                } else {
                    setImgState(2)
                }
                
            } else if(category === "sadri"){
                l = 1;
            }
            else {
                if(pos && pos === "F"){
                    setImgState(1)
                    setLoad(false)
                }else {
                    setImgState(2)
                    setLoad(false)
                }
            }
            
            
        } else{
            
            if(category === "suit"){
                if(type === "Coat"){

                    if(pos === "F"){
                        if(imgState !== 1){
                            setImgState(0)
                        }
                                                     
                    } else {
                        setImgState(2)
                    }   
                    setLoad(false)
                }
                if(type === "Shirt"){
                    // setLoad(true)
                    setImgState(3)
                    setLoad(false)                                                          
                }
                
                if(type === "Vest"){
                    // setLoad(true)
                    var i = 0
                    if(sel && sel.types && sel.types.includes("Shirt")){
                        i = 6
                    }else{
                        i = 5
                    }
                    setImgState(i)
                    setLoad(false) 
                }
    
                if(type === "Pant"){
                    var i = 0
                    if(sel && sel.types && sel.types.includes("Shirt")){
                        i = 4
                    }else{
                        i = 3
                    }
                    // setLoad(true)
                    if(pos === "F"){
                        setImgState(i)                                                        
                    } else {
                        setImgState(i+1)
                    }
                    setLoad(false)   
                }
            } else if( category === "kurta" || category === "ethnic" ){
                const sType = String(type || "").trim();
                const sStyle = String(style || "").trim().toLowerCase();

                const hasCoat = sel && sel.types && sel.types.includes("Coat");
                const hasSadri = sel && sel.types && sel.types.includes("Sadri");

                if (hasCoat) {
                    // --- SITUATION 3 LOGIC (Kurta + Pajama + Coat) ---
                    // Slides: -1 (Coat), 0 (Kurta), 1 (Kurta Fold), 2 (Pajama), 3 (Coat Front), 4 (Coat Back)
                    if (sType === "Kurta") {
                        if (sStyle.includes("button") || sStyle.includes("neck placket") || sStyle.includes("pocket") || sStyle.includes("flap") || sStyle.includes("shoulder epa") || sStyle.includes("collar") || sStyle.includes("sleeve")) {
                            if (imgState === -1 || imgState === 2 || imgState === 3 || imgState === 4) setImgState(0);
                        } else if (sStyle.includes("length") || sStyle.includes("bottom cut")) {
                            if (imgState === 1 || imgState === 2 || imgState === 3 || imgState === 4) setImgState(0);
                        } else if (sStyle.includes("cuff")) {
                            if (imgState === -1 || imgState === 0 || imgState === 2 || imgState === 3 || imgState === 4) setImgState(1);
                        }
                    } else if (sType === "Pajama") {
                        if (sStyle.includes("belt")) {
                            if (imgState === -1 || imgState === 0 || imgState === 1 || imgState === 3 || imgState === 4) setImgState(2);
                        } else if (sStyle === "style") {
                            if (imgState === 1 || imgState === 2 || imgState === 3 || imgState === 4) setImgState(0);
                        }
                    } else if (sType === "Coat") {
                        if (sStyle.includes("back style")) {
                            if (imgState === -1 || imgState === 0 || imgState === 1 || imgState === 2 || imgState === 3) setImgState(4);
                        } else if (sStyle.includes("button")) {
                            if (imgState === 0 || imgState === 1 || imgState === 2) setImgState(-1);
                        } else {
                            // single brested, tuxedo, laple, jodhpuri, etc.
                            if (imgState === 0 || imgState === 1 || imgState === 2) setImgState(-1);
                            else if (imgState === 4) setImgState(3);
                        }
                    }
                } else if (hasSadri) {
                    // --- SITUATION 2 LOGIC (Kurta + Pajama + Sadri) ---
                    if (sType === "Kurta") {
                        if (sStyle.includes("button") || sStyle.includes("neck placket") || sStyle.includes("pocket") || sStyle.includes("collar")) {
                            if (imgState === -1 || imgState === 2 || imgState === 3) setImgState(0);
                        } else if (sStyle.includes("length") || sStyle.includes("bottom cut")) {
                            if (imgState === 1 || imgState === 2 || imgState === 3) setImgState(0);
                        } else if (sStyle.includes("flap")) {
                            if (imgState === -1) setImgState(1);
                            else if (imgState === 2 || imgState === 3) setImgState(0);
                        } else if (sStyle.includes("shoulder epa") || sStyle.includes("sleeve")) {
                            if (imgState === 2) setImgState(0);
                        } else if (sStyle.includes("cuff")) {
                            if (imgState === -1 || imgState === 0 || imgState === 2 || imgState === 3) setImgState(1);
                        }
                    } else if (sType === "Pajama") {
                        if (sStyle.includes("belt")) {
                            if (imgState === -1 || imgState === 0 || imgState === 1 || imgState === 3) setImgState(2);
                        } else if (sStyle === "style") {
                            if (imgState === 1 || imgState === 3) setImgState(0);
                        }
                    } else if (sType === "Sadri") {
                        if (sStyle.includes("button") || sStyle === "style") {
                            if (imgState === 0 || imgState === 1 || imgState === 2) setImgState(-1);
                        } else if (sStyle.includes("pocket")) {
                            if (imgState === -1) setImgState(0);
                            else if (imgState === 0 || imgState === 1 || imgState === 2) setImgState(-1);
                        }
                    }
                } else {
                    // --- SITUATION 1 LOGIC (Kurta + Pajama only) ---
                    if(sType === "Pajama"){
                        if (sStyle.includes("belt")) {
                            if (imgState === 0 || imgState === 1) {
                                setImgState(2);
                            }
                        } else if (sStyle === "style") {
                            if (imgState === 1) {
                                setImgState(2);
                            }
                        }
                    }
                    
                    if(sType === "Kurta"){
                        if (sStyle.includes("cuff")) {
                            if (imgState === 0 || imgState === 2) {
                                setImgState(1);
                            }
                        } else if (sStyle.includes("length") || sStyle.includes("bottom cut")) {
                            if (imgState === 1 || imgState === 2) {
                                setImgState(0);
                            }
                        } else {
                            if (imgState === 2) {
                                setImgState(0);
                            }
                        }
                    }

                    if(type === "Coat" || type === "Sadri"){
                        if(imgState === -1 || 
                            (imgState === 2 && type === "Coat") 
                            || (imgState === 3 && type === "Coat") 
                        ){
                            if( ( imgState === -1 || imgState === 2) && pos === "B"){  
                                setImgState(3)
                            }
                            if(imgState === 3 && pos === "F" && type === "Coat"){
                                setImgState(2)
                            }
                            if(imgState === -1 && pos != "B"){
                                l =1 
                            }
                        } else {
                            if(pos === "F"){
                                if(type === "Sadri"){
                                    setImgState(3)
                                    l=1
                                } else{
                                    setImgState(2)
                                }
                            } else {
                                setImgState(3)
                            }
                        }
                    }
                }

            }
        
            
        }

        return l;
    } catch(e){ 
        console.log("From changeImgState function", e)
    }
}

export const checkStyleConditions=(sel, value, jodh=null, val1 = null)=>{
    try{    
        
        let condition = false
        const styleF = sel.style[value.name].F
        const styleB = sel.style[value.name].B

        if(value.name === "Kurta"){
            
            if((value.type === "Pocket Type" && styleF[2] === "00")
                || (value.type === "Flap Type" && styleF[4] === "0")
                || (value.type === "Cuff Style" && styleF[8] === "SN")
                || (value.type.includes("Flap") && styleF[2] === "00" )
                || ( ["CR", "CB", "CT", "CS", "CE"].includes(styleF[7]) && ["NS4", "QS4"].includes(val1?.value) )
                || ( !["CR", "CB", "CT", "CS", "CE"].includes(styleF[7]) && ["NS3", "QS3"].includes(val1?.value) )
            ){
                condition = true
            } 
        }
        if(value.name === "Pajama"){

            if(value.type === "Belt" && styleF[0] === "PP"){
                condition = true;
            }
        }

        if(value.name === "Sadri"){
            if(value.type === "Pocket" && sadriHasBasePocket(styleF[0])){
                condition = true;
            }
        }

        if(value.name === "Coat"){
            if(value.type === "Stitch" && val1.value === "Y" && styleF[0][0] === "J"){
                condition = true;
            }
            if((value.type === "Lapel" || value.type === "Pocket" ) && styleF[0][0] === "J" ){
                condition = true;
            }
        }
        if(condition) {return condition}


        condition = (jodh && value["type"]=== "Lapel") 
        || (jodh && value["name"] === "Tuxedo")
        || (jodh && value["type"] === "Front Pocket" && val1?.value === "R") 
        || (value["type"] === "Front Pocket" && val1?.value === "R" && sel.style.Pant && sel.style.Pant.F[0] === "F-NP" && sel.style.Pant.F[2] === "G" )
        || (value["type"] === "Front Pocket" && val1?.value === "R" && sel.style.Pant && sel.style.Pant.F[0] === "F-SP")
        || (value["type"] === "Belt Style" && sel.style.Pant && sel.style.Pant.F[0] === "F-NP" && val1?.value === "G" &&  sel.style.Pant.F[1] === "R")
        || ( value["type"] === "Cuffs" && sel.style.Shirt && sel.style.Shirt.F[3] === "H" )


        

        

        return condition
    } catch(e){

    }
}

export const enableStyleSelection = (sel, value, val1)=>{
    const isJodhPuri = sel.style?.Coat?.F[0][0] === "J" ? true : false;
    const selectedValue = sel.style?.[value.name]?.[value.pos]?.[value.n];
    const optionValue = val1?.value;
    const isTuxedoOption = value.category === "tuxedo" || String(value.type || "").toLowerCase().includes("tuxedo") || String(optionValue || "").startsWith("T-");
    const normalizedOptionValue = String(optionValue || "").startsWith("T-") ? String(optionValue).slice(2) : optionValue;
    return(
        (selectedValue === optionValue && ((value.n !== 0 && value.name === "Coat") || (value.name !== "Coat") ) ) ||
        (value.n === 0 && selectedValue === optionValue && !isTuxedoOption && (!sel.tuxedo || isJodhPuri) ) ||
        (isTuxedoOption && selectedValue === normalizedOptionValue && sel.tuxedo)
    )
}

export const getStyleDetails = (sel, category) => {
        try{
            var StylesDets = {}
            const normalizedCat = String(category || "").toLowerCase();
            const Stylesfilter_to_use = (normalizedCat.includes("kurta") || normalizedCat.includes("only_kurta") || normalizedCat.includes("pajama") || normalizedCat.includes("sadri") || normalizedCat.includes("ethnic")) ? StylesFilter_kurta
                                        : normalizedCat.includes("blazer") ? StylesFilter_Blazer
                                        : StylesFilter
            // console.log("coming here in Styles des funct")
            if(sel && sel.style){
                    
                Object.keys(sel["style"]).forEach((t)=>{
                    StylesDets[t] = []
                    Object.keys(sel["style"][t]).forEach((side)=>{
                        
                        var value = null;
                        var img = null;
                        sel["style"][t][side].forEach((val, k)=>{
                            if( (t!=="Shirt") 
                                || (t === "Shirt" && val!= "BASE" && val!="SLEVE")
                                
                            ){
                            
                            var r = null
                            
                            if(t === "Coat" && side === "F" && val[0] === "J"){
                                r = Stylesfilter_to_use.find((filter) => filter.type === "Jodhpuri");
                                console.log("r:", r)
                            } else{
                                r = Stylesfilter_to_use.find((filter) => filter.name === t && filter.pos === side && filter.n === k);
                            }
                            
                            if(!r){
                                return
                            }
                            // console.log(r, side, t)
                            if( checkStyleConditions(sel, r) ){
                                return
                            }
                            // console.log("from inside", r["attr"])
                            for(let i = 0;i<r["attr"].length;i++){
                                if(value){break}
                                if( Array.isArray(r["attr"][i])){
                                    for(let j = 0;j<r["attr"][i].length;j++){
                                        // console.log("of a type:", r["attr"][i][j])
                                        if(r["attr"][i][j]["value"] === val){
                                            value = r["attr"][i][j]["name"]
                                            img = r["attr"][i][j]["img"]
                                            break    
                                        }
                                    }
                                }else{
                                    if(r["attr"][i]["value"] === val){
                                        value = r["attr"][i]["name"]
                                        img = r["attr"][i]["img"]
                                        break
                                    }
                                }
                            }
                            
                            if(value){
                                StylesDets[t].push( {"type":r["type"], "name":value, "img":img})
                            }
                            
                            //  `${r["type"]} : ${value}`
                            value = null
                            }
                        })
                    })
                })

                
            } 
            return StylesDets
        } catch(e){
            console.log(e)
        }
    }

/**
 * "Send Your Design" request: reference photos go to Storage first, then the
 * enquiry is written to `queries` (the collection anonymous visitors can
 * already write to). If Storage refuses the upload the request is still saved
 * with photosFailed so nothing is lost and the customer is pointed to WhatsApp.
 */
export const submitDesignRequest = async (data, files = []) => {
    const id = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const photos = [];
    let photosFailed = 0;

    for (let i = 0; i < files.length; i += 1) {
        const file = files[i];
        try {
            const ext = file.type === "image/png" ? "png" : file.type === "image/webp" ? "webp" : "jpg";
            const url = await handleFireBaseUpload(`photo_${i + 1}.${ext}`, file, `design-requests/${id}`);
            photos.push(url);
        } catch (e) {
            console.warn("design photo upload failed", e?.message || e);
            photosFailed += 1;
        }
    }

    const record = {
        ...data,
        id,
        formType: "design_photo",
        subject: "Send Your Design",
        photos,
        photosFailed,
        photoCount: files.length,
        createdAt: new Date(),
    };

    const saved = await addData(db.collection("queries"), "", record);
    if (!saved) return { ok: false, photos, photosFailed };

    trackEvent("design_photo_request", { garment: data.garment || "", requestType: data.requestType || "" });
    identifyVisitor({ name: data.name, email: data.email, phone: data.phone });

    const summary = [
        data.name && `Name: ${data.name}`,
        data.phone && `Phone: ${data.phone}`,
        data.garment && `Garment: ${data.garment}`,
        data.requestType && `For: ${data.requestType}`,
        data.quantity && `Qty: ${data.quantity}`,
        `Photos: ${photos.length}/${files.length}`,
    ].filter(Boolean).join(" | ");

    await createNotification(
        "design_photo",
        "New Design Photo Request",
        summary,
        "/admin/24",
        {
            formType: "design_photo",
            name: data.name || "",
            phone: data.phone || "",
            email: data.email || "",
            city: data.city || "",
            garment: data.garment || "",
            requestType: data.requestType || "",
            occasion: data.occasion || "",
            quantity: data.quantity || "",
            fabricNote: data.fabricNote || "",
            message: data.des || "",
            photos,
            photosFailed,
        }
    );

    return { ok: true, photos, photosFailed };
};

export const addReachus = async(data, type)=>{

    const coll = db.collection('queries');
    await addData(coll, "", data);

    trackEvent("enquiry", { formType: data["formType"] || "general" });
    identifyVisitor({ name: data["name"], email: data["email"], phone: data["phone"] });

    // Trigger real-time notification
    const enquiryDetails = [
        data["email"] && `Email: ${data["email"]}`,
        data["phone"] && `Phone: ${data["phone"]}`,
        data["des"] && `Message: "${data["des"]}"`
    ].filter(Boolean).join(" | ");

    const enquiryDetailsObj = {
        formType: data["formType"] || "general",
        issueType: data["issueType"] || "",
        email: data["email"] || "",
        phone: data["phone"] || "",
        name: data["name"] || "",
        city: data["city"] || "",
        subject: data["subject"] || "",
        orderNo: data["orderNo"] || "",
        message: data["des"] || "",
    };

    const notifTitle = data["subject"]
        ? `General Enquiry — ${data["subject"]}`
        : "New General Enquiry";

    await createNotification(
        "general",
        notifTitle,
        enquiryDetails || `Enquiry from ${data["email"] || 'Anonymous'}: ${data["des"] || 'No description'}.`,
        "/admin/1",
        enquiryDetailsObj
    );
}

function uint8ToBase64(uint8) {
  return btoa(String.fromCharCode.apply(null, uint8));
}

// Utility: Convert base64 back to Uint8Array
function base64ToUint8(base64) {
  const binary = atob(base64);
  const uint8 = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    uint8[i] = binary.charCodeAt(i);
  }
  return uint8;
}

function base64UrlSafeEncode(uint8Array) {
  return btoa(String.fromCharCode.apply(null, uint8Array))
    .replace(/\+/g, '-')  // Replace + with -
    .replace(/\//g, '_')  // Replace / with _
    .replace(/=+$/, '');  // Remove trailing =
}

function base64UrlSafeDecode(base64) {
  base64 = base64
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  // Pad with '=' to make it valid base64 length
  while (base64.length % 4 !== 0) {
    base64 += '=';
  }

  const binary = atob(base64);
  const uint8 = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    uint8[i] = binary.charCodeAt(i);
  }
  return uint8;
}

export const encodeObj = (data)=>{
    let D = ""
    if (typeof data === 'string' || data instanceof String){
        D = data
    } else {
        D = JSON.stringify(data)
    }
    const deflated = pako.deflate(D);
    return base64UrlSafeEncode(deflated);

      
    // return compress(strToU8(D));
}

export const decodeObj = (base64)=>{
    if (typeof base64 === 'string' && base64.startsWith('~')) {
        const restored = readPersistedRoutePayload(base64);
        if (restored) {
            return JSON.parse(restored);
        }

        return null;
    }

    return JSON.parse(pako.inflate(base64UrlSafeDecode(base64), { to: 'string' }));
    // return JSON.parse(u8ToStr(decompress(data)))
}

const ROUTE_CACHE_PREFIX = 'mavi_route_payload:';
const ROUTE_CACHE_INDEX_KEY = 'mavi_route_payload:index';
const ROUTE_CACHE_LIMIT = 30;

const getRoutePayloadStorage = () => {
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage || window.sessionStorage || null;
    } catch {
        return null;
    }
};

const buildRoutePayloadToken = () => `~${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;

const persistEncodedRoutePayload = (payload) => {
    const storage = getRoutePayloadStorage();
    if (!storage) return null;

    try {
        const token = buildRoutePayloadToken();
        const cacheKey = `${ROUTE_CACHE_PREFIX}${token}`;
        storage.setItem(cacheKey, payload);

        const rawIndex = storage.getItem(ROUTE_CACHE_INDEX_KEY);
        const existingIndex = rawIndex ? JSON.parse(rawIndex) : [];
        const nextIndex = [token, ...existingIndex.filter((item) => item !== token)].slice(0, ROUTE_CACHE_LIMIT);
        storage.setItem(ROUTE_CACHE_INDEX_KEY, JSON.stringify(nextIndex));

        existingIndex.slice(ROUTE_CACHE_LIMIT - 1).forEach((oldToken) => {
            storage.removeItem(`${ROUTE_CACHE_PREFIX}${oldToken}`);
        });

        return token;
    } catch {
        return null;
    }
};

const readPersistedRoutePayload = (token) => {
    const storage = getRoutePayloadStorage();
    if (!storage || !token) return null;

    try {
        return storage.getItem(`${ROUTE_CACHE_PREFIX}${token}`);
    } catch {
        return null;
    }
};

// Persist a design object locally and return a short `~token` usable as the
// route :info param (decodeObj resolves it back). Returns null if storage is
// unavailable so callers can fall back to the full encoded string.
export const createRouteToken = (obj) => {
    try {
        return persistEncodedRoutePayload(JSON.stringify(obj));
    } catch {
        return null;
    }
};

export function categorizeHexColor(hex) {
    // Remove leading '#' if present
    hex = hex.replace(/^#/, '');

    // Convert short hex to full hex
    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    // Convert hex to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate brightness for black/white/gray detection
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Categorize neutral tones
    if (brightness < 50) return 'black';
    if (brightness > 230) return 'white';
    if (Math.abs(r - g) < 10 && Math.abs(r - b) < 10 && Math.abs(g - b) < 10) return 'gray';

    // Convert RGB to HSV for color-based classification
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    let hue = 0;

    if (delta !== 0) {
        if (max === r) {
            hue = ((g - b) / delta) % 6;
        } else if (max === g) {
            hue = (b - r) / delta + 2;
        } else {
            hue = (r - g) / delta + 4;
        }
        hue = Math.round(hue * 60);
        if (hue < 0) hue += 360;
    }

    // Hue-based categorization
    if (hue >= 0 && hue < 15) return 'red';
    if (hue >= 15 && hue < 45) return 'orange';
    if (hue >= 45 && hue < 70) return 'yellow';
    if (hue >= 70 && hue < 170) return 'green';
    if (hue >= 170 && hue < 255) return 'blue';
    if (hue >= 255 && hue < 320) return 'purple';
    if (hue >= 320 && hue <= 360) return 'red'; // red wraps around

    return 'gray'; // fallback
}

export function extractUniqueFabricAttributes(fabric) {
    const Pattern = new Set();
    const Color = new Set();
    const Material = new Set();
    const Ocassion = new Set();
    const Brand = new Set();

    for (const pieceType in fabric) {
        const items = fabric[pieceType];
        items.forEach(item => {
            if (item.pattern) Pattern.add(item.pattern.toLowerCase());
            // the filter offers "pure cotton", "poly viscose"... not each mill's spelling of the blend
            const type = clothType(item);
            if (type) Material.add(type.toLowerCase());
            if (item.ocassion) Ocassion.add(item.ocassion.toLowerCase());
            if (item.brand) Brand.add(item.brand.toLowerCase());

            if (Array.isArray(item.colorCode)) {
                item.colorCode.forEach(code => {
                    Color.add(categorizeHexColor(code.toLowerCase()));
                });
            }
        });
    }

    return {
        Pattern: {attrs: Array.from(Pattern), q : 0},
        Color: {attrs : Array.from(Color), q : 1},
        Material: {attrs : Array.from(Material), q : 0},
        Ocassion: {attrs : Array.from(Ocassion), q : 0},
        Brand : {attrs : Array.from(Brand), q:0}
        // fabricType : {attrs : [], q : 0}
    };
}

export function applyFilters(products, filters, clothList, sel, getStyleImg, category) {
  let filtered = [...products];

  if (filters && filters.Color && filters.Color.length > 0) {
    filtered = filtered.filter(product =>
      product.colorCode.some(color => filters.Color.includes(categorizeHexColor(color.toLowerCase())))
    );
  }

  if (filters && filters.Material && filters.Material.length > 0) {
    filtered = filtered.filter(product =>
      filters.Material.includes(clothType(product).toLowerCase())
    );
  }

  if (filters && filters.fabricType && filters.fabricType.length > 0) {
    filtered = filtered.filter(product =>
      filters.fabricType.includes(product.fabricType.toLowerCase())
    );
  }

  if (filters && filters.Pattern && filters.Pattern.length > 0) {
    filtered = filtered.filter(product =>
      filters.Pattern.includes(product.pattern.toLowerCase())
    );
  }

  if (filters && filters.Brand && filters.Brand.length > 0) {
    filtered = filtered.filter(product =>
      filters.Brand.includes(product.brand.toLowerCase())
    );
  }

  if (filters.sortBy === "highToLow") {
    filtered.sort((a, b) => Number(b.price) - Number(a.price));
  } else {
    filtered.sort((a, b) => Number(a.price) - Number(b.price));
  }
  const ids=  []
  filtered.map((vals)=>{ids.push(vals.id)})

  let filteredList = {...clothList}

  Object.keys(filteredList).map((k)=>{
    const x = filteredList[k].filter(vals => ids.includes(vals.fabricID))
    if(x.length > 0){
        filteredList[k] = x
    }
    
    filteredList[k].sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
  })

// console.log("Filtered List", filteredList)
const fabricIdSets = Object.values(filteredList)
  .map(arr => new Set(arr.map(item => item.fabricID)));

let commonFabricId = null;
if (fabricIdSets.length > 0) {
  // Take the first set and check which fabricID is present in all sets
  for (let fabricId of fabricIdSets[0]) {
    if (fabricIdSets.every(set => set.has(fabricId))) {
      commonFabricId = fabricId;
      break;
    }
  }
}

  if(sel){
    var updatedSel = {...sel}
    console.log("Updated Sel", updatedSel, "filteredList", filteredList, "commonFabricId", commonFabricId);

    sel.types.forEach((ele)=>{
        if((ele !== "Shirt" && category === "Suit") || category !== "Suit"){

            var value_ele;
            const def_fabs = commonFabricId
            value_ele =  filteredList[ele].filter(e=>e.fabricID === def_fabs)

            if(!value_ele.length){value_ele = filteredList[ele][0]}
            else { value_ele = value_ele[0] }

            console.log(ele, "value_ele", value_ele)
            updatedSel = {...updatedSel, 
            ...{
            "fabric":{
            ...updatedSel["fabric"], 
            ...{[ele]:{"fabric":value_ele.fabric, "fabricImg":value_ele.fabricImg, 
            "brand":value_ele.brand, "price": value_ele.price, "src":value_ele.src, "pos":Types[category][ele],
            "single":value_ele["single"], "style":value_ele["style"], "id":value_ele["id"], "fabricID":value_ele["fabricID"], "discount":value_ele["discount"], "brandImg" : value_ele["brandImg"]
            }}
            }
            }}
        }
    })
    console.log("Updated Sel after filter", updatedSel)
    const price = calPrice(updatedSel)
    // setStylesAll({
    //     "Coat":{},
    //     "Vest":{},
    //     "Shirt":{},
    //     "Pant":{}
    // })
    // // console.log("--------UPDATING FABRIC", updatedSel)

    getStyleImg({...updatedSel, ...{"price":price[0], "discount":price[1]}}, 1)
    }
    



  return filteredList;
}

export const filterPresets = (presets, filters, priceToggle, customizeToggle) =>{
    try{
        let filteredPresets = {...presets};
        Object.keys(presets).forEach((key)=>{
            let filtered = [...presets[key]];
            if (filters && filters.Pattern && filters.Pattern.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "pattern", filters.Pattern)
                );
            }
            if (filters && filters.Occasion && filters.Occasion.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "ocassion", filters.Occasion)
                );
            }

            if (filters && filters.Material && filters.Material.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "material", filters.Material)
                );
            }

            if (filters && filters.Type && filters.Type.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "type", filters.Type)
                );
            }

            if (filters && filters.Color && filters.Color.length > 0) {
                filtered = filtered.filter(preset =>
                    selectFromFilter(preset, "colorCode", filters.Color, 1)
                );
            }
            filteredPresets[key] = filtered;
            if (filtered.length === 0) {
                delete filteredPresets[key];
            }
        });
        
        
        
        Object.keys(filteredPresets).forEach((key) => {
            filteredPresets[key].sort((a, b) => {
            if (priceToggle) {
                return Number(a.price) - Number(b.price); // Low to High
            } else {
                return Number(b.price) - Number(a.price); // High to Low
            }
            });
        });

        if(customizeToggle){
            Object.keys(filteredPresets).forEach((key) => {
                filteredPresets[key] = filteredPresets[key].filter(preset => preset.customize);
            });
        }
        

        return filteredPresets;
    } catch(e){
        console.log("Error in filterPresets", e)
    }
}

function selectFromFilter(preset, col, values, type = 0){
    try{
        let selected  = false;
        const values_l = values.map((v)=>v.toLowerCase());
        if(!type){
            preset.fabrics.forEach((fabric)=>{
                if(fabric[col] && values_l.includes(fabric[col].toLowerCase())){
                    selected = true;
                    return;
                }
            })
        }
        else {
            preset.fabrics.forEach((fabric)=>{
                const colors = fabric.colorCode.map((c)=>categorizeHexColor(c.toLowerCase()));
                colors.forEach((c)=>{
                    if(c && values_l.includes(c.toLowerCase())){
                        selected = true;
                        return;
                    }
                })
                if(selected) { return; }
            })
        }
        
        return selected;
    } catch(e){
        console.log("Error in selectFromFilter", e)
    }
}

export const getPresetFilters = (presets)=>{

    try{
        const filters = {
            Pattern: {attrs: [], q : 0},
            Color: {attrs : [], q : 1},
            Material: {attrs : [], q : 0},
            Occasion: {attrs : [], q : 0},
            fabricType : {attrs : [], q : 0},
            Type : {attrs : [], q : 0}
        };

        Object.keys(presets).forEach((key)=>{

            presets[key].forEach((preset)=>{
                preset.fabrics.forEach((fabric)=>{
                    if(fabric.pattern && !filters.Pattern.attrs.includes(fabric.pattern.toLowerCase())){
                        filters.Pattern.attrs.push(fabric.pattern.toLowerCase());
                    }
                    if(fabric.material && !filters.Material.attrs.includes(fabric.material.toLowerCase())){
                        filters.Material.attrs.push(fabric.material.toLowerCase());
                    }
                    if(fabric.ocassion && !filters.Occasion.attrs.includes(fabric.ocassion.toLowerCase())){
                        filters.Occasion.attrs.push(fabric.ocassion.toLowerCase());
                    }
                    if(fabric.type && !filters.Type.attrs.includes(fabric.type.toLowerCase())){
                        filters.Type.attrs.push(fabric.type.toLowerCase());
                    }
                    if(Array.isArray(fabric.colorCode)){
                        fabric.colorCode.forEach((color)=>{
                            const categorizedColor = categorizeHexColor(color.toLowerCase());
                            if(categorizedColor && !filters.Color.attrs.includes(categorizedColor)){
                                filters.Color.attrs.push(categorizedColor);
                            }
                        });
                    }
                });
            });
        })

        Object.keys(filters).forEach((key)=>{
            if(filters[key].attrs.length === 0){
                delete filters[key];
            }
        })
            

        return filters;
    } catch(e){
        console.log("Error in getPresetFilters", e)
    }
}

export const getCoatLayers = (side, ref, ref_buttons, name, obj, ref_tuxedo)=>{

    try {
    const L = name.split("-");
    const normalizeCoatType = (value) => {
        const normalized = String(value || "").trim().toUpperCase();
        return normalized === "JA" || normalized === "JC" ? "JO" : normalized;
    };
    const coatType = normalizeCoatType(obj?.style?.Coat?.F?.[0]);
    const isJodhpur = coatType.charAt(0) === "J" ? true : false;
    const hideFrontMainButtons = coatType === "JH" || coatType === "JO";
    const isStitch = (obj?.style?.Coat?.F?.at(-1) || "") === "Y" ? true : false;
    const bottom_pocket = obj.style.Coat.F[2];
    const isTuxedo = obj.tuxedo && Object.keys(obj.tuxedo).length > 0 && !isJodhpur ? true : false;
    const hasKurta = obj.types.includes("Kurta") ? true : false;
    const selectedTuxedoBaseType = String(coatType || "").trim().toUpperCase() === "2B" ? "2B" : "1B";
    let Layers = []
    let buttons = 0;
    let lapel = 0;
    let b_p = 0;
    let u_p = 0;
    let stitch = false;
        
    if(side === "F"){
        buttons = normalizeCoatType(L[0]);
        lapel = L[1];
        b_p = L[2];
        u_p = L[3];
        stitch = L[4] === "Y" ? true : false;
        Layers = [
            {
                "name": isJodhpur ? buttons : (buttons[0] === "6" ? "4B": buttons) 
                    + "-" 
                    + (((buttons[0] === "4" || buttons[0] === "6") && lapel === "N") ? "P" : lapel)
                    + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "base",
                "i" : 0
            },
            {
                "name": hideFrontMainButtons ? "0" : "BC-" + (isJodhpur ? "JH" : buttons) + "-F",
                "col": ref_buttons,
                "types" : ["display"],
                "layer" : "button_display",
                "fromStyle" : true,
                "i" : 1
            },
            {
                "name": hideFrontMainButtons ? "0" : "BC-" + (isJodhpur ? "JH" : buttons) + "-S",
                "col": ref_buttons,
                "types" : ["style"],
                "layer" : "button_style",
                "i" : 2
            },
            {
                "name":isJodhpur ? "BJH-" + b_p : "BP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" + b_p + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "bottom_pocket",
                "i" : 3
            },
            {
                "name": isJodhpur ? "UJH-" + u_p : "UP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" + u_p + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "upper_pocket",
                "i" : 4
            },
            {
                "name":  (isJodhpur || isTuxedo) ? "0" :
                    "L" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" 
                    + (((buttons[0] === "4" || buttons[0] === "6") && lapel === "N") ? "P" : lapel)
                    + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "default_lapel",
                "i" : 5
            },
            {
                "name": (lapel === "S" || isJodhpur) ? "0" : "C" + (buttons[0] === "6" ? "4" : buttons[0]) + (stitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "default_collar",
                "i" : 6
            },
            {
                "name": isJodhpur ? "BJH-" + b_p + (stitch ? "-Y" : "-N") : "BP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-" + b_p + (stitch ? "-Y" : "-N")   ,
                "col": ref,
                "types" : ["style", "display"],
                "layer" : "shadow_bottom_pocket",
                "i" : 7
            },
            {
                "name": "BCS-S",
                "col": ref_buttons,
                "types" : ["style"],
                "layer" : "coat_sleeve_button",
                "i" : 8
            },
        ]

        if(isTuxedo){
            Layers[3].name = "0";
            Layers[7].name = "0";
            Layers.push({
                "name": "TB-" + (buttons[0] === "6" ? "4B" : buttons) + "-" + lapel + "-F",
                "col": ref_tuxedo,
                "types" : ["display"],
                "layer" : "tuxedo_base",
                "fromStyle": true
            });
            Layers.push({
                "name": "TB-" + (buttons[0] === "6" ? "4B" : buttons) 
                + "-" 
                + (((buttons[0] === "4" || buttons[0] === "6") && lapel === "N") ? "P" : lapel) 
                + "-S",
                "col": ref_tuxedo,
                "types" : ["style"],
                "layer" : "tuxedo_base_2nd",
                "fromStyle": true
            });

            Layers.push({
                "name": "BP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-F",
                "col": ref_tuxedo,
                "types" : ["display"],
                "layer" : "tuxedo_bottom_pocket",
                "fromStyle": true
            });
            Layers.push({
                "name": "BP" + (buttons[0] === "6" ? "4" : buttons[0]) + "-S",
                "col": ref_tuxedo,
                "types" : ["style"],
                "layer" : "tuxedo_bottom_pocket_2nd",
                "fromStyle": true
            });

            Layers.push({
                "name": lapel === "S" ? "0" : "TC-" + (buttons[0] === "6" ? "4B" : buttons) + "-F",
                "col": ref_tuxedo,
                "types" : ["display"],
                "layer" : "tuxedo_collar",
                "fromStyle": true
            });
            Layers.push({
                "name": lapel === "S" ? "0" : "TC-" + (buttons[0] === "6" ? "4B" : buttons) + "-S",
                "col": ref_tuxedo,
                "types" : ["style"],
                "layer" : "tuxedo_collar_2nd",
                "fromStyle": true
            });
        }
        
    } else {
        buttons = normalizeCoatType(L[0]);
        Layers =  [
            {
                "name": isJodhpur ? "JH-" + L[0] : L[0],
                "col": ref,
                "types" : ["style"],
                "layer" : "base"
            },
            {
                "name":  isJodhpur? "0" : "BC-" + (isStitch ? "Y" : "N"),
                "col": ref,
                "types" : ["style"],
                "layer" : "base_collar"
            },
            {
                "name":  "BP-" + bottom_pocket + (isStitch ? "-Y" : "-N"),
                "col": ref,
                "types" : ["style"],
                "layer" : "bottom_pocket"
            },
            {
                "name":  "S-BP-" + bottom_pocket,
                "col": ref,
                "types" : ["style"],
                "layer" : "shadow_bottom_pocket"
            },
            {
                "name":  "BCS-B",
                "col": ref_buttons,
                "types" : ["style"],
                "layer" : "base_sleeve_button"
            }
        ]
        if(isTuxedo){
            Layers[2].name = "0";
            Layers[3].name = "0";
            Layers.push({
                name : "TCB",
                col: ref_tuxedo,
                types : ["style"],
                layer : "tuxedo_collar_back",
                fromStyle: true
            })
            Layers.push({
                name : "BP1-B",
                col: ref_tuxedo,
                types : ["style"],
                layer : "tuxedo_bottom_pocket",
                fromStyle: true
            })

        }

    } 

    if(hasKurta){
        const shirt_collars = ["CR", "CB", "CT", "CS", "CE"]
        const Kurta_collar = obj.style.Kurta.F[7];
        const isShirtCollar = shirt_collars.includes(Kurta_collar) ? true : false;
        const coatCollarGroup = (Kurta_collar === "CA" || Kurta_collar === "CN")
            ? "-R"
            : (Kurta_collar === "CM" || Kurta_collar === "CC")
                ? "-C"
                : isShirtCollar
                    ? "-S"
                    : "-C";
        const showJodhpuriUpperPocket = buttons === "JH" || buttons === "JR" || buttons === "JS";
        const tuxedoBaseType = String(buttons || selectedTuxedoBaseType).trim().toUpperCase() === "2B" ? "2B" : "1B";
        const tuxedoCollarPrefix = tuxedoBaseType === "2B" ? "C2" : "C1";
        const tuxedoLapelPrefix = tuxedoBaseType === "2B" ? "L2" : "L1";
        const tuxedoPocketPrefix = tuxedoBaseType === "2B" ? "BP2" : "BP1";
        const filterKurtaTuxLayers = () => {
            Layers = Layers.filter((layer) => ![
                "tuxedo_base",
                "tuxedo_base_2nd",
                "tuxedo_bottom_pocket",
                "tuxedo_bottom_pocket_2nd",
                "tuxedo_collar",
                "tuxedo_collar_2nd",
                "tuxedo_collar_back"
            ].includes(layer?.layer));
        };
        
        
        if(side === "F") {
            Layers[0].name = isJodhpur ? buttons : buttons + "-" + lapel + 
            coatCollarGroup
            Layers[0]["types"] = ["display"]
            
            Layers[3].name = "0" // bottom pocket not required for coat in kurta
            Layers[4].name = (isJodhpur && !showJodhpuriUpperPocket)
                ? "0"
                : (u_p === "1" ? "UP1" : "0");
            Layers[5].name = Layers[5].name !== "0" ? Layers[5].name.slice(0, -2) : "0"
            Layers[6].name = Layers[6].name !== "0" ? Layers[6].name.slice(0, -2) + coatCollarGroup : "0"

            Layers[7].name = Layers[7].name !== "0" ? Layers[7].name.slice(0, -2) : "0"

            if(isTuxedo){
                filterKurtaTuxLayers();
                Layers[5].name = "0";
                Layers[6].name = "0";
                Layers.push({
                    "name": `${tuxedoCollarPrefix}${coatCollarGroup}-F`,
                    "col": ref_tuxedo,
                    "types": ["display"],
                    "layer": "tuxedo_collar",
                    "fromStyle": true
                });
                Layers.push({
                    "name": `${tuxedoLapelPrefix}-${lapel}-F`,
                    "col": ref_tuxedo,
                    "types": ["display"],
                    "layer": "tuxedo_lapel",
                    "fromStyle": true
                });
                Layers.push({
                    "name": `${tuxedoCollarPrefix}-S`,
                    "col": ref_tuxedo,
                    "types": ["style"],
                    "layer": "tuxedo_collar_2nd",
                    "fromStyle": true
                });
                Layers.push({
                    "name": `${tuxedoLapelPrefix}-${lapel}-S`,
                    "col": ref_tuxedo,
                    "types": ["style"],
                    "layer": "tuxedo_lapel_2nd",
                    "fromStyle": true
                });
                Layers.push({
                    "name": `${tuxedoPocketPrefix}-F`,
                    "col": ref_tuxedo,
                    "types": ["display"],
                    "layer": "tuxedo_bottom_pocket",
                    "fromStyle": true
                });
                Layers.push({
                    "name": `${tuxedoPocketPrefix}-S`,
                    "col": ref_tuxedo,
                    "types": ["style"],
                    "layer": "tuxedo_bottom_pocket_2nd",
                    "fromStyle": true
                });
            }

            
            // removing the kurta collar from coat layer for style image
            Layers.splice(1, 0, {
                "name": !isJodhpur ? Layers[0].name.slice(0, -2) : Layers[0].name,
                "col": ref,
                "types": ["style"],
                "layer": "coat_base_style",
                "i": 0
            });
        } else {
            Layers[0].name = isJodhpur ? `JH-${L[0]}` : L[0]
            Layers[1].name = "0"
            Layers[2].name = "0"
            Layers[3].name = "0"
            if(isTuxedo){
                filterKurtaTuxLayers();
                Layers.push({
                    name : "BC",
                    col: ref_tuxedo,
                    types : ["style"],
                    layer : "tuxedo_collar_back",
                    fromStyle: true
                })
                Layers.push({
                    name : "BP1-B",
                    col: ref_tuxedo,
                    types : ["style"],
                    layer : "tuxedo_bottom_pocket",
                    fromStyle: true
                })
            }
        }
        
        
    }

    

    return Layers;
    
    } catch(e){
        console.log("Error in getCoatLayers", e)
    }
}

export const getKurtaLayers = (side, ref, ref_buttons, name, types, Obj, outerwearActive = false)=>{
    try {
        var L = name.split("-")

        if(!L.length){
            throw new Error("Invalid Kurta Style Name")
        }
        const shirt_collars = ["CR", "CB", "CT", "CS", "CE"]
        const mandarin_collars = ["CM", "CC", "CN"]
        const CATEGORY_A_SADRI = ['SR', 'RR', 'SS', 'AA', 'BB', 'CC', 'DD', 'EE', 'FF', 'GG', 'HH', 'KK'];
        const CATEGORY_B_BASE_TYPES = ['L', 'M', 'N'];
        const normalizeCoatType = (value) => {
            const normalized = String(value || "").trim().toUpperCase();
            return normalized === "JA" || normalized === "JC" ? "JO" : normalized;
        };

        const hasCoat = Obj.types.includes("Coat") ? true : false;
        const hasSadri = Obj.types.includes("Sadri") ? true : false;
        const coatOrSadriType = hasCoat ? normalizeCoatType(Obj.style?.Coat?.F?.[0]) : hasSadri ? Obj.style?.Sadri?.F?.[0] : null;
        const coatUsesClosedJodhpuriKurtaCollar = hasCoat ? ["JH", "JR", "JS"].includes(String(coatOrSadriType || "")) : false;
        const sadriRaw = String(hasSadri ? (Obj.style?.Sadri?.F?.[0] || "") : "").trim().toUpperCase();
        const sadriPrefix = sadriRaw.charAt(0);
        const sadriIsCategoryA = hasSadri
            ? (CATEGORY_A_SADRI.includes(sadriRaw) || (!CATEGORY_B_BASE_TYPES.includes(sadriRaw) && !CATEGORY_B_BASE_TYPES.includes(sadriPrefix)))
            : false;

        if(side === "F"){
            let kurta_base = L[0];
            let placket = L[1]
            let pocket = L[2]
            let pocket_style = L[3]
            let pocket_flap = L[4]
            let pocket_flap_style = L[5]
            let shoulder_epaulet = L[6]
            let collar = L[7]
            let sleeve = L[8]
            let cuff = L[9]
            let length = L[10]
            const buttonCol = ref_buttons || ref;
            const buttonMaterial = String(Obj?.fabric?.Kurta?.buttonMaterial || "").trim().toLowerCase();
            const isRing = buttonMaterial === "ring";

            // Outerwear-aware effective state for imgState -1 (mobile parity)
            let skipCollarLayer = false;
            if (outerwearActive && (hasSadri || hasCoat)) {
                // The epaulet "SE" exists only for the bare kurta+pajama. Under outerwear:
                //  - Sadri leaves the shoulders exposed -> use the dedicated over-sadri
                //    epaulet ("SEO"), drawn above the sadri.
                //  - Coat covers the shoulders fully -> the epaulet is not shown at all.
                if (shoulder_epaulet === "SE") {
                    if (hasSadri && !hasCoat) {
                        // Asset doc is "SEO" on most styles (older ones use "SE-WHEN SADRI")
                        // -- NOT "SE0". getLayerNameCandidates falls back so both resolve.
                        shoulder_epaulet = "SEO";
                    } else if (hasCoat) {
                        shoulder_epaulet = "0";
                    }
                }

                if (hasSadri && !hasCoat) {
                    if (sadriIsCategoryA) {
                        // Closed-neck sadri: under-kurta should behave mandarin
                        collar = "CM";
                        pocket = "00";
                        placket = `${(placket || "NS").charAt(0)}S`;
                    } else {
                        // Open-neck sadri: preserve collar family and shift only the placket family.
                        if (shirt_collars.includes(collar)) {
                            placket = `${(placket || "NS").charAt(0)}T`;
                            skipCollarLayer = true;
                        } else {
                            placket = `${(placket || "NS").charAt(0)}S`;
                        }
                    }
                }

                if (hasCoat) {
                    sleeve = "SS";
                    if (coatUsesClosedJodhpuriKurtaCollar) {
                        collar = "CM";
                    } else if (shirt_collars.includes(collar)) {
                        skipCollarLayer = true;
                    }
                }
            }

            const isShirtCollar = shirt_collars.includes(collar) ? true : false;
            const isMandarinCollar = mandarin_collars.includes(collar) ? true : false;
            const isRoundCollar = collar === "CA" || collar === "CN";
            const isLongLength = length === "K" ? true : false;
            const needsOuterwearBase = outerwearActive && isShirtCollar && (hasCoat || hasSadri);

            // R/S -> non-shirt base families
            // D/T/P/Q -> shirt-collar base families
            // D0/T0/P0/Q0 -> shirt base hidden under outerwear
            let KURTA_BASE = kurta_base;
            switch (kurta_base) {
                case "R":
                    if (isShirtCollar){
                        KURTA_BASE = needsOuterwearBase ? (isLongLength ? "D0" : "P0")
                            : (isLongLength ? "D" : "P");
                    } else {
                        KURTA_BASE = isLongLength ? "R" : "K"
                    }
                    break;
                case "S":
                    if (isShirtCollar){
                        KURTA_BASE = needsOuterwearBase ? (isLongLength ? "T0" : "Q0")
                            : (isLongLength ? "T" : "Q");
                    } else {
                        KURTA_BASE = isLongLength ? "S" : "L"
                    }
                    break;
                default:
                    KURTA_BASE = kurta_base;
            }

            const Layers = [
                {
                    "name": KURTA_BASE,
                    "col": ref,
                    "types" : ["display"],
                    "layer" : "base"
                },
                {
                    "name": "BASE" + (isRoundCollar ? "_R" : collar === "CM" ? "_M" : isShirtCollar ? "" : "_C"),
                    "col": ref,
                    "types" : ["style"],
                    "layer" : "base"
                },
                {
                    "name": placket + (isShirtCollar ? "3" : "4"),
                    "col": ref,
                    "types" : ["style", "display"],
                    "layer" : "placket"
                },
                {
                    "name": placket + (isRoundCollar ? "R" : collar === "CC" ? "C" : "0"),
                    "col": ref,
                    "types" : ["style"],
                    "layer" : "placket"
                },
                {
                    "name": isRing ? "0" : isShirtCollar ? (placket[1] === "T" ? "BHT" : "BHN") : "BHC",
                    "col": ref,
                    "types" : ["display"],
                    "layer" : "placket_button_hole"
                },
                {
                    "name": isRing ? "0" : isShirtCollar ? (placket[1] === "T" ? "BHT" : "BHN") : "BHC",
                    "col": ref,
                    "types" : ["style"],
                    "layer" : "placket_button_hole"
                },
                {
                    "name": isShirtCollar ? "BKN-F" : "BKC-F",
                    "col": buttonCol,
                    "types" : ["display"],
                    "layer" : "placket_button",
                    "fromStyle": true
                },
                {
                    "name": isShirtCollar ? "BKN-S" : "BKC-S",
                    "col": buttonCol,
                    "types" : ["style"],
                    "layer" : "placket_button",
                    "fromStyle": true
                },
                // kurta pockets
                {
                    "name": pocket != "00" && pocket[1] === "1" ?  "R"+ pocket_style : "0",
                    "col": ref,
                    "types" : ["style", "display"],
                    "layer" : "pocket_right"
                },
                //pocket flap
                {
                    name : pocket != "00" && pocket_flap === "1" && pocket[1] === "1" ? "FR"+ pocket_flap_style : "0",
                    col : ref,
                    types : ["style", "display"],
                    layer : "pocket_flap_right"
                },
                {
                    "name": !isRing && pocket_flap === "1" ? pocket != "00" && pocket[1] === "1" ?  "BHR" : "0" : "0",
                    "col": ref,
                    "types" : ["style", "display"],
                    "layer" : "pocket_hole_right"
                },
                {
                    "name": pocket_flap === "1" ? pocket != "00" && pocket[1] === "1" ?  "BPR-F" : "0" : "0",
                    "col": buttonCol,
                    "types" : ["display"],
                    "layer" : "pocket_right_button",
                    "fromStyle": true
                },
                {
                    "name": pocket_flap === "1" ? pocket != "00" && pocket[1] === "1" ?  "BPR-S" : "0" : "0",
                    "col": buttonCol,
                    "types" : ["style"],
                    "layer" : "pocket_right_button",
                    "fromStyle": true
                },
                {
                    "name": pocket != "00" && pocket[0] === "1" ?  "L"+ pocket_style : "0",
                    "col": ref,
                    "types" : ["style", "display"],
                    "layer" : "pocket_left"
                },
                {
                    name : pocket != "00" && pocket_flap === "1" && pocket[0] === "1" ? "FL"+ pocket_flap_style : "0",
                    col : ref,
                    types : ["style", "display"],
                    layer : "pocket_flap_left"
                },
                {
                    "name": !isRing && pocket_flap === "1" ? pocket != "00" && pocket[0] === "1" ?  "BHL" : "0" : "0",
                    "col": ref,
                    "types" : ["style", "display"],
                    "layer" : "pocket_hole_left"
                },
                {
                    "name": pocket_flap === "1" ? pocket != "00" && pocket[0] === "1" ?  "BPL-F" : "0" : "0",
                    "col": buttonCol,
                    "types" : ["display"],
                    "layer" : "pocket_left_button",
                    "fromStyle": true
                },
                {
                    "name": pocket_flap === "1" ? pocket != "00" && pocket[0] === "1" ?  "BPL-S" : "0" : "0",
                    "col": buttonCol,
                    "types" : ["style"],
                    "layer" : "pocket_left_button",
                    "fromStyle": true
                },
                // sleeve
                {
                    name: sleeve,
                    col: ref,
                    types : ["style", "display"],
                    layer : "sleeve"
                },
                {
                    name: sleeve ==="SC" ? cuff : "0",
                    col: ref,
                    types : ["style"],
                    layer : "cuff"
                },
                {
                    name: !isRing && sleeve ==="SC" ? cuff[2] === "1" ? "BH2" : cuff[2] === "2" ? "BH4" : "0" : "0",
                    col: ref,
                    types : ["style"],
                    layer : "sleeve_button_hole"
                },
                {
                    name: sleeve ==="SC" ? cuff[2] === "1" ? "BC2-F" : cuff[2] === "2" ? "BC4-F" : "0" : "0",
                    col: buttonCol,
                    types : ["display"],
                    layer : "sleeve_button",
                    "fromStyle": true
                },
                {
                    name: sleeve ==="SC" ? cuff[2] === "1" ? "BC2-S" : cuff[2] === "2" ? "BC4-S" : "0" : "0",
                    col: buttonCol,
                    types : ["style"],
                    layer : "sleeve_button",
                    "fromStyle": true
                },
                ...(!skipCollarLayer ? [
                    {
                        name: collar,
                        col: ref,
                        types : ["style", "display"],
                        layer : "collar"
                    },
                    {
                        name: !isRing && collar === "CB" ? "CBH" : "0",
                        col: ref,
                        types : ["style", "display"],
                        layer : "collar_hole_button"
                    },
                    {
                        name: collar === "CB" ? "CBB-F" : "0",
                        col: buttonCol,
                        types : ["display"],
                        layer : "collar_hole_button_down",
                        "fromStyle": true
                    },
                    {
                        name: collar === "CB" ? "CBB-S" : "0",
                        col: buttonCol,
                        types : ["style"],
                        layer : "collar_hole_button_down",
                        "fromStyle": true
                    },
                ] : []),
                // shoulder epaulet
                {
                    name: shoulder_epaulet,
                    col: ref,
                    types : ["style", "display"],
                    layer : "shoulder_epaulet"
                },
                {
                    name: !isRing && shoulder_epaulet === "SE" ? "HE" : "0",
                    col: ref,
                    types : ["style", "display"],
                    layer : "shoulder_epaulet_hole"
                },
                {
                    name: shoulder_epaulet === "SE" ? "BE-F" : "0",
                    col: buttonCol,
                    types : ["display"],
                    layer : "shoulder_epaulet_button",
                    "fromStyle": true
                },
                {
                    name: shoulder_epaulet === "SE" ? "BE-S" : "0",
                    col: buttonCol,
                    types : ["style"],
                    layer : "shoulder_epaulet_button",
                    "fromStyle": true
                },
            ]

            if (shoulder_epaulet === "SEO") {
                const elevatedLayers = Layers.splice(-4);
                Layers.push(...elevatedLayers.filter((layer) => layer.name && layer.name !== "0"));
            }
            return Layers;
        }
    } catch(e){
        console.log("Error in getKurtaLayers", e)
    }
}

export const getSadriLayers = (side, ref, ref_buttons, name, obj)=>{
    try {
        var L = name.split("-")

        const kurta_collar = obj?.style?.Kurta?.F?.[7] || obj?.sadriInnerWear?.collar || "CM";
        const diff_sardris = ["L", "M", "N"]
        const categoryA = ['SR', 'RR', 'SS', 'AA', 'BB', 'CC', 'DD', 'EE', 'FF', 'GG', 'HH', 'KK'];
        const isShirtCollar = ["CR", "CB", "CT", "CS", "CE"].includes(kurta_collar) ? true : false;
        const isMandarinCollar = ["CM", "CC", "CN"].includes(kurta_collar) ? true : false;
        const buttonMaterial = String(obj?.fabric?.Sadri?.buttonMaterial || "").trim().toLowerCase();
        const isRing = buttonMaterial === "ring";

        if(!L.length){
            throw new Error("Invalid Sadri Style Name")
        }

        
        if(side === "F"){
            const sadriType = String(L[0] || "").trim().toUpperCase();
            const upperPocket = String(L[1] || "").trim();
            const hasBasePocket = sadriHasBasePocket(sadriType);
            const sadriPrefix = sadriType.charAt(0);
            const isCategoryA = categoryA.includes(sadriType);
            const finalSadriBase = isCategoryA
                ? sadriType
                : diff_sardris.includes(sadriType)
                    ? `${sadriType}${kurta_collar === "CA" || kurta_collar === "CN" ? "R" : isShirtCollar ? "S" : isMandarinCollar ? "C" : "R"}`
                    : diff_sardris.includes(sadriPrefix)
                        ? `${sadriPrefix}${kurta_collar === "CA" || kurta_collar === "CN" ? "R" : isShirtCollar ? "S" : isMandarinCollar ? "C" : "R"}`
                        : sadriType;
            const buttonCol = ref_buttons || ref;
            const Layers = [
                {
                    name : finalSadriBase,
                    col : ref,
                    types : ["style", "display"],
                    layer : "base"
                },
                {
                    name : !hasBasePocket && upperPocket === "1" ? "VPOCKET" : "0",
                    col : ref,
                    types : ["style", "display"],
                    layer : "upper_pocket"
                },
                {
                    name : !isRing && finalSadriBase !== "KK" ? "B"+finalSadriBase : "0",
                    col : buttonCol,
                    types : ["style", "display"],
                    layer : "button",
                    "fromStyle": true
                },
            ]
            return Layers;
        }
    } catch(e){
        console.log("Error in getSadriLayers", e)
    }
}

export const getPajamaLayers = (side, ref, name, Obj, kurta_layers)=>{
    try {
        var L = name.split("-")

        if(!L.length){
            throw new Error("Invalid Pajama Style Name")
        }
        // Salwar - PS (elastic options)
        // Dhoti - PD (elastic options)
        // Pajama - PJ (elastic options)
        // Chudidar - PC (elastic options)
        // Patiala - PT (elastic options)
        // ALIGARHI - PA (elastic options)
        // PANT - PP ( no elastic options)
        // BELBOTTOM - PB ( no elastic options)

        const elastic_pajamas = ["PS", "PD", "PJ", "PC", "PT", "PA"]
        const isElastic = elastic_pajamas.includes(L[0]) ? true : false;
        const pajama_base = L[0];

        const kurta_base = kurta_layers?.[0]?.name || "D0";

        if(side === "F"){
            const Layers = [
                {
                    name : `${L[0]}-${kurta_base}`,
                    col : ref,
                    types : ["display"],
                    layer : "base"
                },
                {
                    name :  isElastic ? `${L[0]}-${L[1]}` : pajama_base,
                    col : ref,
                    types : ["style"],
                    layer : "base_second_image"
                },
            ]
            return Layers;
        }
    } catch(e){
        console.log("Error in getPajamaLayers", e)
    }
}


export const getVestLayers = (side, ref, ref_buttons, name, obj, ref_tuxedo)=>{
    try {
        const Layers = [];

        const isTuxedo = obj.tuxedo && Object.keys(obj.tuxedo).length > 0 ? true : false;
        Layers.push({
            "name": name,
            "col": ref,
            "types" : ["style", "display"],
            "layer" : "base"
        });
        Layers.push({
            "name": "B" + name + "-S",
            "col": ref_buttons,
            "types" : ["style"],
            "layer" : "button_style"
        });
        if(isTuxedo){
            Layers.push({
                "name": "TV" + "-F",
                "col": ref_tuxedo,
                "types" : ["display"],
                "layer" : "tuxedo_base",
                "fromStyle": true
            });
            Layers.push({
                "name": "TV" + "-S",
                "col": ref_tuxedo,
                "types" : ["style"],
                "layer" : "tuxedo_base_2nd",
                "fromStyle": true
            });
        }

        return Layers;
    } catch(e){
        console.log("Error in getVestLayers", e)
    }

}

export const getOrderedButtons = (sel, Buttons, valueName) => {
    const inputButtons = Array.isArray(Buttons) ? Buttons : [];
    if (!inputButtons.length) return [];
    const recommended = Array.isArray(sel?.fabric?.[valueName]?.recommended_buttons)
        ? sel.fabric[valueName].recommended_buttons
        : [];
    const defaultRecommended = sel?.fabric?.[valueName]?.default_recommended_button;
    const ordered = [];
    const used = new Set();

    if (defaultRecommended != null && defaultRecommended !== "") {
        const defBtn = inputButtons.find((e) => String(e?.id) === String(defaultRecommended));
        if (defBtn && !used.has(defBtn.id)) {
            ordered.push(defBtn);
            used.add(defBtn.id);
        }
    }

    // Keep DB-provided recommendation order intact.
    recommended.forEach((id) => {
        const button = inputButtons.find((e) => String(e?.id) === String(id));
        if (button && !used.has(button.id)) {
            ordered.push(button);
            used.add(button.id);
        }
    });

    inputButtons.forEach((button) => {
        if (!button || used.has(button.id)) return;
        ordered.push(button);
        used.add(button.id);
    });

    return ordered;
}

/**
 * Admin stores single embroidery renders under Fabric/embroidery/{garment}_{part}
 * (e.g. targetType Sadri + part base → sadri_base), not under kurta_* when garment is Sadri.
 * Collection docs live under {targetCategory}_collections (e.g. kurta_collections); values[].type
 * references that render collection id (e.g. sadri_base).
 * Legacy values may still use kurta_sadri_base — normalize to sadri_base for lookups.
 */
const canonicalEmbroideryRenderType = (typeKey) => {
    const t = String(typeKey || "").trim().toLowerCase();
    if (t === "kurta_sadri_base") return "sadri_base";
    return typeKey;
};

const buildKurtaFrontStyleName = (sel) => {
    const Doc = sel?.style?.Kurta;
    if (!Doc || !Doc.F) return "";
    const ids = Doc.F;
    let name = "";
    ids.forEach((id) => {
        if (id && id.length) name += id + "-";
    });
    if (ids.length === 1) name = ids[0];
    if (name.endsWith("-")) name = name.slice(0, -1);
    return name;
};

const buildSadriFrontStyleName = (sel) => {
    const Doc = sel?.style?.Sadri;
    if (!Doc || !Doc.F) return "";
    const ids = Doc.F;
    let name = "";
    ids.forEach((id) => {
        if (id && id.length) name += id + "-";
    });
    if (ids.length === 1) name = ids[0];
    if (name.endsWith("-")) name = name.slice(0, -1);
    return name;
};

const embTargetCategoryMatches = (category, docTarget) => {
    if (docTarget == null || docTarget === "") return true;
    const t = String(docTarget).trim().toLowerCase();
    const flow = String(category || "").trim().toLowerCase();
    if (flow === "suit") return t === "suits" || t === "suit";
    if (flow === "kurta") return t === "kurta";
    if (flow === "blazer") return t === "blazer";
    if (flow === "sadri") return t === "kurta" || t === "sadri";
    return true;
};

/** Fallback paths if a collection still references the old type string. */
const embroideryCollectionAltTypes = (typeKey) => {
    const t = String(typeKey || "").trim().toLowerCase();
    if (t === "sadri_base") return ["kurta_sadri_base"];
    if (t === "kurta_sadri_base") return ["sadri_base"];
    return [];
};

const expandEmbroideryKeyAliases = (key) => {
    const k = String(key || "");
    const out = [];
    const push = (value) => {
        if (value && value !== k && !out.includes(value)) out.push(value);
    };
    if (/^E-[A-Za-z0-9]+-[FSB]$/.test(k)) {
        push(k.replace(/^E-/, "E"));
    }
    if (/^E[A-Za-z0-9]+-[FSB]$/.test(k)) {
        push(`E-${k.slice(1)}`);
    }
    if (/^E-[A-Za-z0-9]+-[FSB]$/.test(k)) {
        const base = k.slice(0, -2);
        push(base);
        push(base.replace(/^E-/, "E"));
    }
    if (/^E[A-Za-z0-9]+-[FSB]$/.test(k)) {
        const base = k.slice(0, -2);
        push(base);
        push(`E-${base.slice(1)}`);
    }
    if (k.includes("_")) {
        push(k.replace(/_/g, "-"));
        push(k.replace(/_/g, ""));
        if (/-[FSB]$/.test(k)) {
            const base = k.slice(0, -2);
            push(base);
            push(base.replace(/^E-/, "E"));
            push(base.replace(/_/g, "-"));
            push(base.replace(/_/g, ""));
            push(base.replace(/^E-/, "E").replace(/_/g, "-"));
            push(base.replace(/^E-/, "E").replace(/_/g, ""));
        }
    }
    return out;
};

const resolveEmbroideryResourceUrl = (resources, primaryName) => {
    if (!resources || !primaryName) return null;
    const tryKeys = [primaryName, ...expandEmbroideryKeyAliases(primaryName)];
    for (const k of tryKeys) {
        if (resources[k]) return resources[k];
    }
    const keys = Object.keys(resources);
    if (keys.length === 1 && resources[keys[0]]) return resources[keys[0]];
    return null;
};

const embroideryTypeToFabricKey = (typeKey, sel) => {
    const t = String(typeKey || "").toLowerCase();
    if (t.startsWith("coat") || t === "coat_lapel") return "Coat";
    if (t.includes("sadri")) return "Sadri";
    if (t.startsWith("kurta")) return "Kurta";
    return "Coat";
};

const embroideryPriceToNumber = (value) => {
    if (value == null) return 0;
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    if (typeof value === "string") {
        const cleaned = value.replace(/[^\d.-]/g, "");
        if (!cleaned.length) return 0;
        const parsed = Number(cleaned);
        return Number.isFinite(parsed) ? parsed : 0;
    }
    return 0;
};

const embroideryTypeToGarmentKey = (typeKey) => {
    const t = String(typeKey || "").trim().toLowerCase();
    if (t.startsWith("coat")) return "coat";
    if (t.includes("sadri")) return "sadri";
    if (t.startsWith("kurta")) return "kurta";
    if (t.startsWith("shirt")) return "shirt";
    if (t.startsWith("vest")) return "vest";
    if (t.startsWith("pant")) return "pant";
    if (t.startsWith("pajama")) return "pajama";
    return "";
};

const getEmbroideryDocRefs = (value, embCollection, category, resolvedType) => {
    const refs = [];
    const seen = new Set();
    const pushRef = (path) => {
        const p = String(path || "").trim();
        if (!p || seen.has(p)) return;
        seen.add(p);
        refs.push(db.doc(p));
    };

    const docId = value && value.id;
    if (!docId) return refs;

    const rawPath = value && value.refPath ? String(value.refPath).trim() : "";
    if (rawPath) {
        pushRef(rawPath);
    }

    const docType = String(value && value.targetType ? value.targetType : "").trim().toLowerCase();
    const collType = String(embCollection && (embCollection.targetType || embCollection._targetType) ? (embCollection.targetType || embCollection._targetType) : "").trim().toLowerCase();
    const inferredType = embroideryTypeToGarmentKey(resolvedType);
    const tryTypes = [docType, collType, inferredType].filter(Boolean);

    const docCat = String(value && value.targetCategory ? value.targetCategory : "").trim().toLowerCase();
    const collCat = String(embCollection && (embCollection.targetCategory || embCollection._targetCategory) ? (embCollection.targetCategory || embCollection._targetCategory) : "").trim().toLowerCase();
    const flowCat = category === "suit" ? "suits" : category === "kurta" ? "kurta" : category === "blazer" ? "blazer" : category === "sadri" ? "sadri" : "";
    const tryCats = [docCat, collCat, flowCat].filter(Boolean);

    tryCats.forEach((cat) => {
        tryTypes.forEach((typ) => {
            pushRef(`Fabric/embroidery/${cat}/${typ}/embroideries/${docId}`);
        });
    });

    return refs;
};

const getEmbroideryRenderDocData = async (value, embCollection, category, resolvedType) => {
    const typeKey = value?.type;
    const docId = value?.id;
    if (!docId) return null;
    const tryTypes = [typeKey, resolvedType, ...embroideryCollectionAltTypes(typeKey), ...embroideryCollectionAltTypes(resolvedType)]
        .map((val) => String(val || "").trim())
        .filter(Boolean);
    const refPaths = getEmbroideryDocRefs(value, embCollection, category, resolvedType);
    for (const t of tryTypes) {
        refPaths.push(db.collection("Fabric").doc("embroidery").collection(t).doc(docId));
    }
    for (const docRef of refPaths) {
        const data = await getDatafromDoc(docRef);
        if (data && data.resources) return data;
    }
    return null;
};

const getEmbroideryValuePlacement = (value) => {
    const normalize = (val) => String(val || "").trim().toLowerCase();
    const targetType = normalize(value?.targetType);
    const targetPart = normalize(value?.targetPart);
    if (targetPart) {
        return { garment: targetType, part: targetPart };
    }
    const typeKey = normalize(value?.type);
    const typePieces = typeKey.split("_");
    if (typePieces.length >= 2) {
        return {
            garment: typePieces[typePieces.length - 2] || "",
            part: typePieces[typePieces.length - 1] || "",
        };
    }
    const refPath = normalize(value?.refPath);
    if (refPath) {
        const pieces = refPath.split("/");
        return {
            garment: pieces.length >= 4 ? pieces[3] : "",
            part: pieces.length >= 6 ? pieces[5] : "",
        };
    }
    return { garment: targetType, part: "" };
};

const isEmbroideryValueAllowedForSelection = (value, sel) => {
    const placement = getEmbroideryValuePlacement(value);
    if (placement.garment !== "sadri") return true;
    const sadriCode = String(sel?.style?.Sadri?.F?.[0] || "").trim().toUpperCase();
    if (!sadriCode) return true;
    const part = String(placement.part || "").trim().toLowerCase();
    if (part === "base" && sadriBaseEmbroideryDisabled(sadriCode)) return false;
    if ((part === "collar" || part === "lapel") && sadriCollarEmbroideryDisabled(sadriCode)) return false;
    return true;
};

export const getEmbroideryCollectionResolvedPrice = async (collection, category, selectedStyleId = null, sel = null) => {
    if (!collection || !Array.isArray(collection.values)) return 0;
    let total = 0;
    const valuesForSelectedStyle = collection.values.filter((value) => {
        if (!selectedStyleId) return true;
        if (value?.style === undefined || value?.style === null) return true;
        return String(value.style) === String(selectedStyleId);
    });

    for (const value of valuesForSelectedStyle) {
        if (sel && !isEmbroideryValueAllowedForSelection(value, sel)) continue;
        const resolvedType = canonicalEmbroideryRenderType(value?.type);
        const data = await getEmbroideryRenderDocData(value, collection, category, resolvedType);
        if (!data || !embTargetCategoryMatches(category, data.targetCategory)) continue;
        total += embroideryPriceToNumber(data.price);
    }
    return total;
};

const computeKurtaEmbroideryPositions = (sel, outerwearActive = false) => {
    const name = buildKurtaFrontStyleName(sel);
    if (!name) return null;
    const layers = getKurtaLayers("F", null, null, name, sel.types || [], sel, outerwearActive);
    if (!layers || !layers.length) return null;
    let d = 0;
    let s = 0;
    const pos = { kurtaBaseCode: layers[0].name };
    for (let li = 0; li < layers.length; li++) {
        const layer = layers[li];
        const lk = layer.layer;
        // Skip "0" named layers — Fabric/index.js does not push them to
        // style_images / display_images so the counter must not advance for them.
        const layerNameIsEmpty = !layer.name || String(layer.name) === "0";
        for (let ti = 0; ti < layer.types.length; ti++) {
            const typ = layer.types[ti];
            if (typ === "display") {
                if (!layerNameIsEmpty) {
                    if (lk === "base" && layer.name === layers[0].name) pos.kurta_base_display = d + 1;
                    if (lk === "sleeve") {
                        pos.kurta_sleeve_display = d + 1;
                        pos.kurtaSleeveCode = layer.name;
                    }
                    if (lk === "sleeve_button" && pos.kurta_cuff_button_display == null) {
                        pos.kurta_cuff_button_display = d + 1;
                    }
                    if (lk === "collar") {
                        pos.kurta_collar_display = d + 1;
                        pos.kurtaCollarCode = layer.name;
                    }
                    if (lk === "pocket_right") {
                        pos.kurta_pocket_display = d + 1;
                        pos.kurtaPocketCode = layer.name;
                    }
                    if (lk === "shoulder_epaulet") {
                        pos.kurta_epaulette_display = d + 1;
                        pos.kurtaEpauletteCode = layer.name;
                    }
                    if (lk === "placket") {
                        pos.kurta_lapel_display = d + 1;
                        pos.kurtaLapelCode = layer.name;
                    }
                    d++;
                }
            }
            if (typ === "style") {
                if (!layerNameIsEmpty) {
                    if (lk === "base" && layer.name && String(layer.name).startsWith("BASE")) pos.kurta_base_style = s + 1;
                    if (lk === "sleeve") pos.kurta_sleeve_style = s + 1;
                    if (lk === "cuff") {
                        pos.kurta_cuff_style = s + 1;
                        pos.kurtaCuffCode = layer.name;
                    }
                    if (lk === "sleeve_button_hole" && pos.kurta_cuff_button_hole_style == null) {
                        pos.kurta_cuff_button_hole_style = s + 1;
                    }
                    if (lk === "sleeve_button" && pos.kurta_cuff_button_style == null) {
                        pos.kurta_cuff_button_style = s + 1;
                    }
                    if (lk === "collar") pos.kurta_collar_style = s + 1;
                    if (lk === "pocket_right") pos.kurta_pocket_style = s + 1;
                    if (lk === "shoulder_epaulet") pos.kurta_epaulette_style = s + 1;
                    if (lk === "placket") pos.kurta_lapel_style = s + 1;
                    s++;
                }
            }
        }
    }
    const selectedCollarCode = sel.style?.Kurta?.F?.[7] || "CM";
    const hiddenShirtCollarBaseCodes = ["D0", "T0", "P0", "Q0"];
    const shirtCollarCodes = ["CR", "CB", "CT", "CS", "CE"];
    if (
        outerwearActive
        && pos.kurta_collar_display == null
        && hiddenShirtCollarBaseCodes.includes(pos.kurtaBaseCode)
        && shirtCollarCodes.includes(selectedCollarCode)
    ) {
        pos.kurta_hidden_collar_display = pos.kurta_epaulette_display != null
            ? Math.max(pos.kurta_epaulette_display - 1, 0)
            : d;
        pos.kurtaHiddenCollarCode = selectedCollarCode;
    }
    return pos;
};

const computeSadriEmbroideryPositions = (sel) => {
    const name = buildSadriFrontStyleName(sel);
    if (!name) return null;
    const layers = getSadriLayers("F", null, null, name, sel);
    if (!layers || !layers.length) return null;
    return {
        sadri_base_display: 1,
        sadri_base_style: 1,
        sadriBaseCode: layers[0].name,
    };
};

const applyEmbroideryLayer = (sel, fabricKey, name, url, applied) => {
    if (!url || !sel.fabric || !sel.fabric[fabricKey]) return;
    const fabric = sel.fabric[fabricKey];
    const record = (kind) => { if (Array.isArray(applied)) applied.push({ fabricKey, kind, url }); };
    if (name.type === "display") {
        if (!Array.isArray(fabric.src)) fabric.src = [].concat(fabric.src || []);
        if (Object.hasOwn(name, "pos")) fabric.src.splice(name.pos, 0, url);
        else fabric.src.push(url);
        record("src");
    } else if (name.type === "display_default") {
        if (!Array.isArray(fabric.default)) fabric.default = [].concat(fabric.default || []);
        if (Object.hasOwn(name, "pos")) fabric.default.splice(name.pos, 0, url);
        else fabric.default.push(url);
        record("default");
    } else if (name.type === "style") {
        if (!fabric.single || !fabric.single[0]) return;
        if (!Array.isArray(fabric.single[0].src)) fabric.single[0].src = [].concat(fabric.single[0].src || []);
        if (Object.hasOwn(name, "pos")) fabric.single[0].src.splice(name.pos, 0, url);
        else fabric.single[0].src.push(url);
        record("single0");
    } else if (name.type === "back") {
        if (!fabric.single || !fabric.single[1]) return;
        if (!Array.isArray(fabric.single[1].src)) fabric.single[1].src = [].concat(fabric.single[1].src || []);
        if (Object.hasOwn(name, "pos")) fabric.single[1].src.splice(name.pos, 0, url);
        else fabric.single[1].src.push(url);
        record("single1");
    }
};

const decodeUrlForLayerMatch = (url) => {
    try {
        return decodeURIComponent(String(url || ""));
    } catch (e) {
        return String(url || "");
    }
};

const getPocketHiddenLayerMatcher = (fabricKey, resolvedType, category) => {
    const key = String(fabricKey || "").trim().toLowerCase();
    const type = String(resolvedType || "").trim().toLowerCase();
    const flow = String(category || "").trim().toLowerCase();

    if (key === "coat" && type === "coat_base") {
        return (url) => {
            const normalized = decodeUrlForLayerMatch(url);
            return /\/Coat\/UP[^/]*-/i.test(normalized) || /%2FCoat%2FUP[^?&]*-/i.test(String(url || ""));
        };
    }

    if (key === "sadri" && type === "sadri_base") {
        return (url) => {
            const normalized = decodeUrlForLayerMatch(url);
            return /\/Sadri\/VPOCKET[^/]*-/i.test(normalized) || /%2FSadri%2FVPOCKET[^?&]*-/i.test(String(url || ""));
        };
    }

    if (key === "kurta" && type === "kurta_base" && (flow === "kurta" || flow === "ethnic")) {
        return (url) => {
            const normalized = decodeUrlForLayerMatch(url);
            return /\/Kurta\/(R|L)[^/]*-/i.test(normalized);
        };
    }

    return null;
};

const hidePocketLayersForEmbroidery = (sel, fabricKey, resolvedType, category, applied) => {
    if (!sel?.fabric?.[fabricKey] || !Array.isArray(applied)) return;
    const matchesHiddenPocketLayer = getPocketHiddenLayerMatcher(fabricKey, resolvedType, category);
    if (!matchesHiddenPocketLayer) return;

    const fabric = sel.fabric[fabricKey];
    const removeFromArr = (arr, kind) => {
        if (!Array.isArray(arr)) return;
        for (let idx = arr.length - 1; idx >= 0; idx -= 1) {
            const url = arr[idx];
            if (!matchesHiddenPocketLayer(url)) continue;
            arr.splice(idx, 1);
            applied.push({ fabricKey, kind: `hidden:${kind}`, url, pos: idx });
        }
    };

    removeFromArr(fabric.src, "src");
    removeFromArr(fabric.default, "default");
    removeFromArr(fabric.single?.[0]?.src, "single0");
    removeFromArr(fabric.single?.[1]?.src, "single1");

    if (fabricKey === "Coat" && resolvedType === "coat_base" && sel.style?.Coat?.F?.[3] !== "0") {
        applied.push({ fabricKey, kind: "hidden:style", path: ["Coat", "F", 3], value: sel.style.Coat.F[3] });
        sel.style.Coat.F[3] = "0";
    }

    if (fabricKey === "Sadri" && resolvedType === "sadri_base" && sel.style?.Sadri?.F?.[1] !== "0") {
        applied.push({ fabricKey, kind: "hidden:style", path: ["Sadri", "F", 1], value: sel.style.Sadri.F[1] });
        sel.style.Sadri.F[1] = "0";
    }
};

export const stripEmbroideryFromSel = (sel, embItemsToRemove) => {
    if (!sel || !sel.fabric) return sel;
    const list = Array.isArray(embItemsToRemove) ? embItemsToRemove : [embItemsToRemove];
    list.forEach((emb) => {
        const applied = Array.isArray(emb?.applied) ? emb.applied : [];
        applied.forEach(({ fabricKey, kind, url, pos, path, value }) => {
            const fabric = sel.fabric[fabricKey];
            if (!fabric && kind !== "hidden:style") return;
            const restoreToArr = (arr) => {
                if (!Array.isArray(arr) || !url || arr.includes(url)) return;
                const safePos = Number.isInteger(pos) ? Math.max(0, Math.min(pos, arr.length)) : arr.length;
                arr.splice(safePos, 0, url);
            };
            const removeFromArr = (arr) => {
                if (!Array.isArray(arr)) return;
                const idx = arr.lastIndexOf(url);
                if (idx >= 0) arr.splice(idx, 1);
            };
            if (typeof kind === "string" && kind.startsWith("hidden:")) {
                const restoreKind = kind.slice("hidden:".length);
                if (restoreKind === "style") {
                    if (!Array.isArray(path) || path.length !== 3 || !sel.style?.[path[0]]?.[path[1]]) return;
                    sel.style[path[0]][path[1]][path[2]] = value;
                } else if (restoreKind === "src") {
                    if (!Array.isArray(fabric.src)) fabric.src = [].concat(fabric.src || []);
                    restoreToArr(fabric.src);
                } else if (restoreKind === "default") {
                    if (!Array.isArray(fabric.default)) fabric.default = [].concat(fabric.default || []);
                    restoreToArr(fabric.default);
                } else if (restoreKind === "single0") {
                    if (!fabric.single || !fabric.single[0]) return;
                    if (!Array.isArray(fabric.single[0].src)) fabric.single[0].src = [].concat(fabric.single[0].src || []);
                    restoreToArr(fabric.single[0].src);
                } else if (restoreKind === "single1") {
                    if (!fabric.single || !fabric.single[1]) return;
                    if (!Array.isArray(fabric.single[1].src)) fabric.single[1].src = [].concat(fabric.single[1].src || []);
                    restoreToArr(fabric.single[1].src);
                }
            } else if (kind === "src") removeFromArr(fabric.src);
            else if (kind === "default") removeFromArr(fabric.default);
            else if (kind === "single0") removeFromArr(fabric.single?.[0]?.src);
            else if (kind === "single1") removeFromArr(fabric.single?.[1]?.src);
        });
    });
    return sel;
};

export const setEmbroideryImages = async (Obj, category) => {
    try {
        let sel = { ...Obj };
        const embs = Array.isArray(sel["embroidery"]) ? sel["embroidery"].map((emb) => ({ ...emb })) : sel["embroidery"];
        if (!embs || !sel.fabric) return sel;
        const insertionPositions = {};
        const insertionKey = (fabricKey, name) => `${fabricKey}:${String(name?.type || "")}`;
        const getAdjustedInsertionName = (fabricKey, name) => {
            if (!Object.hasOwn(name || {}, "pos")) return name;
            const basePos = Number(name.pos);
            if (!Number.isFinite(basePos)) return name;
            const priorPositions = insertionPositions[insertionKey(fabricKey, name)] || [];
            const offset = priorPositions.filter((pos) => pos < basePos).length;
            return { ...name, pos: basePos + offset, _originalPos: basePos };
        };
        const trackInsertionPosition = (fabricKey, name) => {
            if (!Object.hasOwn(name || {}, "_originalPos")) return;
            const key = insertionKey(fabricKey, name);
            if (!insertionPositions[key]) insertionPositions[key] = [];
            insertionPositions[key].push(name._originalPos);
        };

        for (let i = 0; i < embs.length; i++) {
            let embTotalPrice = 0;
            const allValues = embs[i].values;
            const selectedStyleId = embs[i]?._selectedStyle || embs[i]?.selectedStyle || embs[i]?.style || null;
            let values = allValues;
            if (selectedStyleId && Array.isArray(allValues)) {
                const filteredValues = allValues.filter((val) => {
                    if (!val) return false;
                    if (!val.style) return true;
                    return String(val.style) === String(selectedStyleId);
                });
                if (filteredValues.length > 0) {
                    values = filteredValues;
                }
            }
            if (!values) continue;
            embs[i].applied = [];
            for (let j = 0; j < values.length; j++) {
                const typeKey = values[j].type;
                const resolvedType = canonicalEmbroideryRenderType(typeKey);
                const docId = values[j].id;
                if (!isEmbroideryValueAllowedForSelection(values[j], sel)) {
                    continue;
                }
                const data = await getEmbroideryRenderDocData(values[j], embs[i], category, resolvedType);
                if (!data || !data.resources) {
                    console.log("Embroidery doc missing resources for ", typeKey, docId);
                    continue;
                }
                if (data.targetCategory != null && !embTargetCategoryMatches(category, data.targetCategory)) {
                    continue;
                }
                const fabricKey = embroideryTypeToFabricKey(resolvedType, sel);
                if (!sel.fabric[fabricKey]) continue;

                if (data.pocketHidden === true) {
                    hidePocketLayersForEmbroidery(sel, fabricKey, resolvedType, category, embs[i].applied);
                }

                const fileNames = getFileNamesFromType(resolvedType, sel, category);
                // Insert from highest pos to lowest so earlier splices don't
                // shift the positions of later (lower-pos) inserts on the same array.
                // Group by output array kind so types remain independent.
                const orderedFileNames = Array.isArray(fileNames)
                    ? [...fileNames].sort((a, b) => {
                        const ka = String(a?.type || "");
                        const kb = String(b?.type || "");
                        if (ka !== kb) return ka < kb ? -1 : 1;
                        const pa = Object.hasOwn(a || {}, "pos") ? Number(a.pos) : -Infinity;
                        const pb = Object.hasOwn(b || {}, "pos") ? Number(b.pos) : -Infinity;
                        return pb - pa; // descending within same type
                    })
                    : fileNames;
                let renderApplied = false;
                orderedFileNames.forEach((name) => {
                    if (name.requiresResource && !resolveEmbroideryResourceUrl(data.resources, name.requiresResource)) return;
                    const candidateNames = [name.name, ...(Array.isArray(name.fallbackNames) ? name.fallbackNames : [])];
                    const url = candidateNames.map((candidateName) => resolveEmbroideryResourceUrl(data.resources, candidateName)).find(Boolean);
                    if (url) {
                        const adjustedName = getAdjustedInsertionName(fabricKey, name);
                        applyEmbroideryLayer(sel, fabricKey, adjustedName, url, embs[i].applied);
                        trackInsertionPosition(fabricKey, adjustedName);
                        renderApplied = true;
                    }
                    else console.log("Embroidery not found for ", candidateNames.join(" / "), fabricKey);
                });
                if (renderApplied) embTotalPrice += embroideryPriceToNumber(data.price);
            }
            embs[i]._resolvedPrice = embTotalPrice;
            embs[i].price = embTotalPrice;
        }
        sel.embroidery = embs;
        return sel;
    } catch (e) {
        console.log("from emboridery image retrival", e);
        return Obj;
    }
};

export const getCollectionNamesFromCategory = (category)=>{
    let coll  = category === "suit" ? "Suits" 
                    : category === "formal" || category === "pant" || category === "shirt" ? "formal"
                    : category === "kurta" ? "kurta" 
                    : category === "blazer" ? "blazer"
                    : category === "sadri" ? "kurta"
                    : "dummy" ;
    return coll;
}

export const getFileNamesFromType = (type, sel, category)=>{
    try{
        switch(type){
            case "coat_base":
                return CoatBaseEmbNames(sel, category);
            case "coat_collar":
                return CoatCollarEmbNames(sel, category);
            case "Coat_lapel":
            case "coat_lapel":
                return CoatLapelEmbNames(sel, category);
            case "Coat_sleeve":
            case "coat_sleeve":
                return CoatBaseSleeveEmbNames(sel, category);
            case "kurta_base":
                return KurtaBaseEmbNames(sel);
            case "kurta_sleeve":
                return KurtaSleeveEmbNames(sel);
            case "kurta_collar":
                return KurtaCollarEmbNames(sel);
            case "kurta_pocket":
                return KurtaPocketEmbNames(sel);
            case "kurta_epaulette":
                return KurtaEpauletteEmbNames(sel);
            case "kurta_lapel":
                return KurtaLapelEmbNames(sel);
            case "sadri_base":
            case "kurta_sadri_base":
                return SadriBaseEmbNames(sel);
            case "sadri_collar":
            case "kurta_sadri_collar":
                return SadriCollarEmbNames(sel);
            default:
                return []
        }
    } catch(e){
        console.log("getFileNamesFromType ", e)
        return []
    }
}

const getKurtaCoatEmbCode = (coatType = "", viewSuffix = "F") => {
    const t = String(coatType || "").trim().toUpperCase();
    if (!t) return "";
    if (viewSuffix === "B") {
        if (["1B", "2B"].includes(t)) return "CDC";
        if (["JH", "JR", "JS", "JO"].includes(t)) return "JDC";
        return "CDC";
    }
    if (["1B", "2B"].includes(t)) return t === "2B" ? "C2" : "C1";
    if (["JH", "JR", "JS"].includes(t)) return "JDC";
    if (t === "JO") return "JDO";
    return "";
};

const getKurtaCoatLapelEmbCode = (coatType = "", lapel = "N") => {
    const t = String(coatType || "").trim().toUpperCase();
    const l = String(lapel || "N").trim().toUpperCase();
    if (t === "2B") return `L2-${l}`;
    if (t === "1B") return `L1-${l}`;
    return "";
};

const isKurtaCategoryFlow = (category) => String(category || "").toLowerCase() === "kurta";

const CoatBaseEmbNames = (obj, category)=>{
    try {
        if (!obj?.style?.Coat?.F || !obj.style.Coat.F[0]) return [];
        const buttons = obj.style.Coat.F[0];

        if (isKurtaCategoryFlow(category)) {
            const coatType = String(obj?.style?.Coat?.F?.[0] || "").trim().toUpperCase();
            if (!coatType) return [];
            return [
                { name: `E-${coatType}-S`, type: "style", pos: 1 },
                { name: `E-${coatType}-F`, type: "display", pos: 1 }
            ];
        }
        if(buttons[0] === "J"){
            return [ 
                    {
                        name : "E"+ buttons + "-S",
                        type : "style",
                        pos : 1
                    },
                    {
                        name : "E"+ buttons + "-F" ,
                        type : "display",
                        pos : 1
                    }
                ]
        } else {
            return [ 
                    {
                        name : "EB" + (buttons[0] === "6" ? "4" : buttons[0]) + "-S",
                        type : "style",
                        pos : 1
                    },
                    {
                        name : "EB" + (buttons[0] === "6" ? "4" : buttons[0]) + "-F" ,
                        type : "display",
                        pos : 1
                    }
                ]
        }


    } catch(e){
        console.log("CoatBaseEmbNames ", e)
    }
}

const CoatBaseSleeveEmbNames = (sel, category) =>{
    try {
        if (isKurtaCategoryFlow(category)) {
            return [
                { name : "E-SL-S", type : "style", pos : 1 },
                { name : "E-SL-F", type : "display", pos : 1 },
                { name : "E-SL-B", type : "back", pos : 1 }
            ]
        }
        return [
            {
                name : "ES-S",
                type : "style",
                pos : 1
            },
            {
                name : "ES-F" ,
                type : "display",
                pos : 1
            },
            {
                name : "ES-B" ,
                type : "back",
                pos : 1
            }
        ]
    } catch(e){
        console.log("CoatBaseSleeveEmbNames  ", e)
    }
}

const CoatLapelEmbNames = (obj, category)=>{
    try {
        if (!obj?.style?.Coat?.F || !obj.style.Coat.F[0]) return [];
        const buttons = obj.style.Coat.F[0];
        const lapel = obj.style.Coat.F[1];

        if (isKurtaCategoryFlow(category)) {
            const code = getKurtaCoatLapelEmbCode(buttons, lapel);
            if (!code) return [];
            return [
                { name: `E-${code}-F`, type : "display" },
                { name: `E-${code}-S`, type : "style" }
            ]
        }
        if(buttons[0] == "J"){
            return []
        } else {
            return [
                {
                    name: "EL-" + (buttons[0] === "6" ? "4B" : buttons) + "-" + lapel + "-F",
                    type : "display"
                },
                {
                    name: "EL-" + (buttons[0] === "6" ? "4B" : buttons) + "-" + lapel + "-S",
                    type : "style"
                }
            ]
        }
        

    } catch(e){
        console.log("CoatLapelEmbNames  ", e)
    }
}

const CoatCollarEmbNames = (obj, category)=>{
    try {   
        if (!obj?.style?.Coat?.F || !obj.style.Coat.F[0]) return [];
        const buttons = obj.style.Coat.F[0];

        if (isKurtaCategoryFlow(category)) {
            const frontCode = getKurtaCoatEmbCode(buttons, "F");
            const styleCode = getKurtaCoatEmbCode(buttons, "S");
            const backCode = getKurtaCoatEmbCode(buttons, "B");
            const out = [];
            if (frontCode) out.push({ name : `E-${frontCode}-F`, type : "display" });
            if (styleCode) out.push({ name : `E-${styleCode}-S`, type : "style" });
            if (backCode) out.push({ name : `E-${backCode}-B`, type : "back" });
            return out;
        }
        return [
            {
                name : "EC-" + (buttons[0] === "6" ? "4B" : buttons === "JR" ? "JH" : buttons) + "-F", 
                type : "display"
            },
            {
                name : "EC-" + (buttons[0] === "6" ? "4B" : buttons === "JR" ? "JH" : buttons) + "-S", 
                type : "style"
            },
            {
                name : "EC-" + (buttons[0] === "6" ? "4B" : buttons === "JR" ? "JH" : buttons) + "-B", 
                type : "back"
            }
        ]

    } catch(e){
        console.log("CoatCollarEmbNames  ", e)
    }
}

const KurtaBaseEmbNames = (sel) => {
    try {
        const pos = computeKurtaEmbroideryPositions(sel, false);
        if (!pos || pos.kurta_base_display == null) return [];
        const collarCode = sel.style?.Kurta?.F?.[7] || "CM";
        const usesRoundChineseCollarBase = ["CA", "CN"].includes(collarCode);
        const foldedBaseEmbroidery = usesRoundChineseCollarBase ? "E-BASE_R-S" : "E-BASE-S";
        const out = [
            // standalone kurta (imgState 0)
            { name: `E-${pos.kurtaBaseCode}-F`, type: "display", pos: pos.kurta_base_display },
            {
                name: foldedBaseEmbroidery,
                type: "style",
                pos: pos.kurta_base_style,
                fallbackNames: usesRoundChineseCollarBase ? ["E-BASE-S"] : [],
            },
        ];
        const outerPos = computeKurtaEmbroideryPositions(sel, true);
        if (outerPos && outerPos.kurta_base_display != null) {
            // under outerwear (imgState -1)
            out.push({ name: `E-${outerPos.kurtaBaseCode}-F`, type: "display_default", pos: outerPos.kurta_base_display });
        }
        return out;
    } catch (e) {
        console.log("KurtaBaseEmbNames ", e);
    }
};

const KurtaSleeveEmbNames = (sel) => {
    try {
        const pos = computeKurtaEmbroideryPositions(sel, false);
        if (!pos || pos.kurta_sleeve_display == null) return [];
        const sleeveCode = pos.kurtaSleeveCode || sel.style?.Kurta?.F?.[8] || "SN";
        const cuffCode = pos.kurtaCuffCode || sel.style?.Kurta?.F?.[9] || "";
        const out = [];
        if (sleeveCode === "SC") {
            // E-CUF-F must be pushed BEFORE E-SC-F in the out array.
            // Both share the same splice position (kurta_sleeve_display). The
            // descending-pos sort in setEmbroideryImages is stable, so equal-pos
            // entries are applied in their original array order.  Applying
            // E-CUF-F first, then E-SC-F at the same pos produces:
            //   [..., sleeve, E-SC-F, E-CUF-F, BC2-F]  ← E-CUF-F on top. ✓
            const cuffDisplayPos = pos.kurta_cuff_button_display != null
                ? Math.min(pos.kurta_sleeve_display, pos.kurta_cuff_button_display - 1)
                : pos.kurta_sleeve_display;
            const cuffStylePos = pos.kurta_cuff_button_hole_style != null
                ? Math.min(pos.kurta_cuff_style || pos.kurta_sleeve_style, pos.kurta_cuff_button_hole_style - 1)
                : (pos.kurta_cuff_style || pos.kurta_sleeve_style);
            out.push({ name: "E-CUF-F", type: "display", pos: cuffDisplayPos });
            if (cuffCode && cuffCode !== "0" && cuffStylePos != null) {
                out.push({ name: `E-${cuffCode}-S`, type: "style", pos: cuffStylePos, requiresResource: "E-CUF-F" });
            }
        }
        out.push({ name: `E-${sleeveCode}-F`, type: "display", pos: pos.kurta_sleeve_display });
        out.push({ name: `E-${sleeveCode}-S`, type: "style", pos: pos.kurta_sleeve_style });
        const outerPos = computeKurtaEmbroideryPositions(sel, true);
        if (outerPos && outerPos.kurta_sleeve_display != null) {
            const outerSleeveCode = outerPos.kurtaSleeveCode || sleeveCode;
            // Cuff embroidery (E-CUF-F) must also land in the outerwear/sadri-set default
            // images, not only the standalone slide. Mirror the standalone branch above:
            // push the cuff BEFORE the sleeve at the same (clamped) position so it layers
            // on top of the sleeve. Without this the cuff embroidery vanished in the sadri set.
            if (outerSleeveCode === "SC") {
                const outerCuffDisplayPos = outerPos.kurta_cuff_button_display != null
                    ? Math.min(outerPos.kurta_sleeve_display, outerPos.kurta_cuff_button_display - 1)
                    : outerPos.kurta_sleeve_display;
                out.push({ name: "E-CUF-F", type: "display_default", pos: outerCuffDisplayPos });
            }
            out.push({ name: `E-${outerSleeveCode}-F`, type: "display_default", pos: outerPos.kurta_sleeve_display });
        }
        return out;
    } catch (e) {
        console.log("KurtaSleeveEmbNames ", e);
    }
};

const KurtaCollarEmbNames = (sel) => {
    try {
        const pos = computeKurtaEmbroideryPositions(sel, false);
        if (!pos || pos.kurta_collar_display == null) return [];
        const collarCode = pos.kurtaCollarCode || sel.style?.Kurta?.F?.[7] || "CM";
        const foldedCollarEmbroideryMap = { CM: "CC", CC: "CM" };
        const foldedCollarCode = foldedCollarEmbroideryMap[collarCode] || collarCode;
        const out = [
            { name: `E-${collarCode}-F`, type: "display", pos: pos.kurta_collar_display },
            { name: `E-${foldedCollarCode}-S`, type: "style", pos: pos.kurta_collar_style },
        ];
        const outerPos = computeKurtaEmbroideryPositions(sel, true);
        if (outerPos && outerPos.kurta_collar_display != null && outerPos.kurtaCollarCode) {
            out.push({ name: `E-${outerPos.kurtaCollarCode}-F`, type: "display_default", pos: outerPos.kurta_collar_display });
        } else if (outerPos && outerPos.kurta_hidden_collar_display != null && outerPos.kurtaHiddenCollarCode) {
            out.push({ name: "ECOLLAR", type: "display_default", pos: outerPos.kurta_hidden_collar_display });
        }
        return out;
    } catch (e) {
        console.log("KurtaCollarEmbNames ", e);
    }
};

const KurtaPocketEmbNames = (sel) => {
    try {
        const pos = computeKurtaEmbroideryPositions(sel, false);
        if (!pos || pos.kurta_pocket_display == null) return [];
        const pocketCode = pos.kurtaPocketCode || ("R" + (sel.style?.Kurta?.F?.[3] || "R"));
        const out = [
            { name: `E-${pocketCode}-F`, type: "display", pos: pos.kurta_pocket_display },
            { name: `E-${pocketCode}-S`, type: "style", pos: pos.kurta_pocket_style },
        ];
        const outerPos = computeKurtaEmbroideryPositions(sel, true);
        if (outerPos && outerPos.kurta_pocket_display != null && outerPos.kurtaPocketCode && outerPos.kurtaPocketCode !== "0") {
            out.push({ name: `E-${outerPos.kurtaPocketCode}-F`, type: "display_default", pos: outerPos.kurta_pocket_display });
        }
        return out;
    } catch (e) {
        console.log("KurtaPocketEmbNames ", e);
    }
};

const KurtaEpauletteEmbNames = (sel) => {
    try {
        const pos = computeKurtaEmbroideryPositions(sel, false);
        if (!pos || pos.kurta_epaulette_display == null) return [];
        const epCode = pos.kurtaEpauletteCode || sel.style?.Kurta?.F?.[6] || "0";
        const out = [
            { name: `E-${epCode}-F`, type: "display", pos: pos.kurta_epaulette_display },
            { name: `E-${epCode}-S`, type: "style", pos: pos.kurta_epaulette_style },
        ];
        const outerPos = computeKurtaEmbroideryPositions(sel, true);
        if (outerPos && outerPos.kurta_epaulette_display != null && outerPos.kurtaEpauletteCode && outerPos.kurtaEpauletteCode !== "0") {
            out.push({ name: `E-${outerPos.kurtaEpauletteCode}-F`, type: "display_default", pos: outerPos.kurta_epaulette_display });
        }
        return out;
    } catch (e) {
        console.log("KurtaEpauletteEmbNames ", e);
    }
};

const KurtaLapelEmbNames = (sel) => {
    try {
        const pos = computeKurtaEmbroideryPositions(sel, false);
        if (!pos || pos.kurta_lapel_display == null) return [];
        const lapelCode = pos.kurtaLapelCode || (sel.style?.Kurta?.F?.[1] + "4");
        const out = [
            { name: `E-${lapelCode}-F`, type: "display", pos: pos.kurta_lapel_display },
            { name: `E-${lapelCode}-S`, type: "style", pos: pos.kurta_lapel_style },
        ];
        const outerPos = computeKurtaEmbroideryPositions(sel, true);
        if (outerPos && outerPos.kurta_lapel_display != null && outerPos.kurtaLapelCode) {
            out.push({ name: `E-${outerPos.kurtaLapelCode}-F`, type: "display_default", pos: outerPos.kurta_lapel_display });
        }
        return out;
    } catch (e) {
        console.log("KurtaLapelEmbNames ", e);
    }
};

const SadriBaseEmbNames = (sel) => {
    try {
        const pos = computeSadriEmbroideryPositions(sel);
        if (!pos) return [];
        const code = pos.sadriBaseCode;
        return [
            { name: `E-${code}-F`, type: "display", pos: pos.sadri_base_display },
            { name: `E-${code}-S`, type: "style", pos: pos.sadri_base_style },
        ];
    } catch (e) {
        console.log("SadriBaseEmbNames ", e);
    }
};

const SadriCollarEmbNames = (sel) => {
    try {
        const pos = computeSadriEmbroideryPositions(sel);
        if (!pos) return [];
        const code = pos.sadriBaseCode;
        return [
            { name: `E-${code}-F`, type: "display", pos: pos.sadri_base_display },
            { name: `E-${code}-S`, type: "style", pos: pos.sadri_base_style },
        ];
    } catch (e) {
        console.log("SadriCollarEmbNames ", e);
    }
};

export const isEmbEnabled = (category)=>{
    if(category === "suit" || category === "kurta" || category === "only_kurta" || category === "sadri"){
        return true
    }
    return false;
}

// try {

// } catch(e){
//     console.log("  ", e)
// }

export const getRowsFromArray = (arr, itemsPerRow, currIndex) => {
    if(!arr || !Array.isArray(arr) || arr.length === 0 || currIndex % itemsPerRow !== 0){
        return [];
    }

    if(currIndex === 0 || currIndex%itemsPerRow === 0){
        return arr.slice(currIndex, currIndex + itemsPerRow);
    }
    return [];
}

export const getSrcImages = async (layers, StylesALL, styleTypes,j )=>{
    let display_images = []
    let style_images  = []
    const getLayerNameCandidates = (name, layerType) => {
        const raw = String(name || "");
        if (!raw || raw === "0") return [];
        if (/^BP\d-[FSB]$/.test(raw) || /^BP\d-[^-]+-[FSB]$/.test(raw)) return [raw];
        const out = [];
        const push = (v) => {
            const key = String(v || "");
            if (!key || out.includes(key)) return;
            out.push(key);
        };
        push(raw);
        if (/-[FS]$/.test(raw)) {
            push(raw.slice(0, -2));
        } else if (layerType === "display") {
            push(`${raw}-F`);
        } else if (layerType === "style") {
            push(`${raw}-S`);
        }
        // Under-outerwear epaulet: newer styles store this asset as "SEO",
        // older ones as "SE-WHEN SADRI". Try both so either style resolves.
        if (raw === "SEO") push("SE-WHEN SADRI");
        return out;
    };
    const fetchLayerSrcWithFallback = async (layerObj, layerType, collType) => {
        const names = getLayerNameCandidates(layerObj?.name, layerType);
        const collections = [];
        const pushCollection = (collectionName) => {
            if (collectionName && !collections.includes(collectionName)) collections.push(collectionName);
        };
        pushCollection(collType || layerType);
        pushCollection(layerType);
        pushCollection("display");
        for (let cIdx = 0; cIdx < collections.length; cIdx += 1) {
            for (let idx = 0; idx < names.length; idx += 1) {
                const docName = names[idx];
                const srcObj = await getDatafromDoc(layerObj["col"].collection(collections[cIdx]).doc(docName));
                if (srcObj && srcObj.src && srcObj.src.length > 0) {
                    return { src: srcObj.src, key: docName };
                }
            }
        }
        return null;
    };

    // Pre-pass: warm the module-level doc cache in parallel so the existing
    // sequential loop below resolves from cache instead of waiting on serial
    // network round-trips. Render output is unchanged.
    {
        const seen = new Set();
        const calls = [];
        for (let layer = 0; layer < layers.length; layer++) {
            const item = layers[layer];
            if (!item || item === "0" || !item.types || !item.col || !item.name || item.name === "0") continue;
            const coll_type = item.fromStyle ? "style" : null;
            for (const t of item.types) {
                if (StylesALL?.[styleTypes[j]]?.[t] && Object.hasOwn(StylesALL[styleTypes[j]][t], item.name)) continue;
                const candidates = getLayerNameCandidates(item.name, t);
                for (const docName of candidates) {
                    const docRef = item["col"].collection(coll_type ? coll_type : t).doc(docName);
                    const path = docRef?.path;
                    if (path && seen.has(path)) continue;
                    if (path) seen.add(path);
                    calls.push(getDatafromDoc(docRef));
                }
            }
        }
        if (calls.length) {
            try { await Promise.all(calls); } catch (e) { /* handled in sequential pass */ }
        }
    }

    for(let layer=0;layer<layers.length;layer++){
        const types_coat = layers[layer]["types"];
        for(let i1=0;i1<types_coat.length;i1++){
            const type_coat = types_coat[i1];
            let coll_type = null;
            if(layers[layer].fromStyle){
                coll_type = "style"
            }
            if(layers[layer] !== "0"){
                // console.log("Coat Style running for : ", layers[layer], StylesALL[styleTypes[j]]["style"] , !Object.hasOwn(StylesALL[styleTypes[j]]["style"], layers[layer]))
                if(StylesALL[styleTypes[j]][type_coat] && !Object.hasOwn(StylesALL[styleTypes[j]][type_coat], layers[layer]["name"])){


                    const srcRes = await fetchLayerSrcWithFallback(layers[layer], type_coat, coll_type);
                    if(!srcRes || !srcRes.src || ( srcRes.src && srcRes.src.length === 0 )){
                        console.log(type_coat + " not available", layers[layer]["name"])
                    } else {
                        
                        StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]] = srcRes.src
                        if(type_coat === "display"){
                            display_images.push(StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]])
                        }
                        else {
                            style_images.push(StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]])
                        }
                        
                    }
                } else {
                    if(type_coat === "display"){
                        display_images.push(StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]])
                    }
                    else {
                        style_images.push(StylesALL[styleTypes[j]][type_coat][layers[layer]["name"]])
                    }
                } 

            }
        }
    }

    return {display_images, style_images};
}